import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationStart, Params, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { catchError, filter, flatMap, map, mergeMap, tap } from 'rxjs/operators';
import { Yii } from "libraries/interfaces/Yii";
import * as moment from 'moment';
import _get from 'lodash-es/get';
import _cloneDeep from 'lodash-es/cloneDeep';
import _includes from 'lodash-es/includes';
import _filter from 'lodash-es/filter';
import _set from 'lodash-es/set';
import _forEach from 'lodash-es/forEach';
import _omit from 'lodash-es/omit';
import _find from 'lodash-es/find';
import _isUndefined from 'lodash-es/isUndefined';
import _invoke from 'lodash-es/invoke';
import _isString from 'lodash-es/isString';
import _isPlainObject from 'lodash-es/isPlainObject';
import { AuthLocobookService } from "./auth/authLocobook.service";
import { SegmentService } from "./service/segment.service";
import { TravellerService } from "./service/traveller/traveller.service";
import { CarrierService } from "./service/carrier.service";
import { PropalService } from "./service/propal/propal.service";
import { SilentBookingService } from "./service/silent-booking.service";
import { PriceService } from "./service/price.service";
import { QuoteService } from "./service/quote.service";
import { SSRService } from "./ssr/ssr.service";
import { PNRService } from "./pnr/pnr.service";
import { RightsService } from "app/shared/services/rights/rights.service";
import { ViewService } from "app/shared/services/views/view.service";
import { FormBuilderService } from "libraries/service/formBuilder/formBuilder.service";
import { BreadcrumbIqbaService } from "./service/breadcrumbIqba/breadcrumbIqba.service";
import { OfferService } from "./service/offer.service";
import { IPermission, IQuote } from 'libraries/model/air-quote/IQuote';
import { ResourceError } from "libraries/service/resource/ResourceError";
import { TravellerFormComponent } from 'libraries/module/formbuilder/forms/travellerForm/travellerForm.component';
import { IWenji, SearchResultOption } from "libraries/interfaces/IWenji";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import {
    AllSegmentDialogComponent,
    IAllSegmentsDialogData
} from "./shared/all-segment-dialog/all-segment-dialog.component";
import { ISegmentSelect } from "./shared/segment-list/all-segment-list.component";
import { IOutSelectQuote } from "./pages/quote-page/components/quote-list-container/quote-list-container.component";
import { SamResourceService } from "libraries/service/resources/sam/samResource.service";
import { ISamAgent } from "libraries/service/resources/sam/ISamAgent";
import { ISamCompany } from "libraries/service/resources/sam/ISamCompany";
import { LowCostCompanyService } from "app_locobook/service/low-cost-company.service";
import { BookingComponent } from './shared/booking/booking.component';
import {
    IFareFamily,
    IGetBookingsAirResponse,
    IRemark,
    ISectorAir
} from 'libraries/service/resources/booking/interfaces/IGetBookings';
import {
    IAirCreateBookingRequest,
    IAirCreateBookingRequestSegment,
    IAirUpdateBookingRequest,
    IOnBookingCreatedNotificationSetup,
    IOnBookingCreationFailedNotificationSetup,
    IOnOfferSelectedNotificationSetup
} from 'libraries/service/resources/model/booking/air/IAirCreateBooking';
import { IAirDisplay } from './pnr/IAirDisplay';
import { INotification, NotificationType } from "libraries/interfaces/INotification";
import { IPnrPageParameters } from "libraries/service/breadcrumb/breadcrumb.service";
import {
    IAirApplicationAutomatorRequest,
    IAirSaveOfferRequest
} from "libraries/service/resources/model/booking/air/IAirSaveOffer";
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { RuntimeError } from "libraries/service/error-tracing/runtime-error.model";
import { NOTEPAD_EDITOR_PERMISSION, NotepadComponent } from "libraries/component/notepad/notepad.component";
import { INotepad } from "libraries/service/resources/booking/interfaces/notepad.interface";
import { PermissionResourceService } from 'libraries/service/resources/permission/permissionResource.service';
import { IPassport } from "libraries/service/resources/hotel/IResourceHotel";
import {
    CreateBookingWarningMessageService,
    IBookingErrorPriceChangedResponse,
    IBookingErrorPriceChangedResponsePayment
} from "app_locobook/service/create-booking-warning-message.service";
import { QuotedAvailabilityService } from "./service/quoted-availability.service";
import {
    IAirGetQuotedAvailabilityRequest
} from "libraries/service/resources/model/booking/air/IAirQuotedAvailability";
import {
    IAirQuotedAvailabilityResponse
} from "libraries/service/resources/model/booking/air/IAirQuotedAvailabilityResponse";
import { SearchFlightFormComponent } from "./searchFlightForm/searchFlightForm.component";
import { IExternalApplicationData } from "libraries/interfaces/IIQBAExternalRelation";

import { faCaretRight, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { EServiceQualityEnum } from "libraries/service/resources/airQuote/airQuoteResource.service";
import { ActionQualityHelperService } from "libraries/service/action-quality-helper/action-quality-helper.service";
import { ActionInBookingType, ResponseForConvertOfferAfx2jsonType } from "@afidium/ts-facade";
import { IBookingExternalLink, IPostAirSearchRequest, ISegment, ISegmentBeginIntervalle, ISegmentBeginValue } from 'libraries/interfaces/i-post-air-search-request';
import { AirQuoteMappingService, EUsedXReason } from 'libraries/service/resources/airQuote/air-quote-mapping.service';
import {
    IOnAlternativeSelectOutput
} from './pages/quote-page/components/fare-family-benchmark/fare-family-benchmark.component';
import { IqbaPathSegment } from './iqba-paths';
import { CacheSamResourceService } from "libraries/service/resources/sam/cache-sam-resource.service";
import { ConfirmDialogComponent } from 'libraries/component/dialogs/confirm-dialog/confirm-dialog.component';
import { IConfirmDialogData } from 'libraries/component/dialogs/confirm-dialog/confirm-dialog.interface';
import { IAirExternalBooking } from "libraries/service/resources/model/booking/air/IAirExternalBooking";
import { AirBookingResourceService } from 'libraries/service/resources/air-booking/air-booking-resource.service';
import { ISectorSimile } from 'libraries/interfaces/i-sector-simile';
import { Location } from "@angular/common";
import { IValidateOutput } from "app_locobook/pages/ancillary-services-page/ancillary-services-page.component";
import {
    CacheQuotedAvailabilityService
} from "app_locobook/service/cache-quoted-availability/cache-quoted-availability.service";
import { EAirBookingPermissions } from "libraries/component/booking-information/e-air-booking-permissions.enum";
import { ApiIssueStatus } from "libraries/service/resources/booking/interfaces/ApiSearchParameters";
import { ApiResourceService } from "libraries/service/apiResource/apiResource.service";
import { BookingCbCacheService } from "app_locobook/service/booking-cb-cache.service";
import {
    AirBookingConditionApplyService
} from "app_locobook/domain/ancillaryServices/useCases/air-booking-condition-apply.service";
import { TExternalService } from "libraries/model/extenal-service/externalService";
import {
    DictionaryRoutesHostsResourceService
} from "libraries/service/resources/dictionary-routes-hosts/dictionary-routes-hosts-resource.service";
import { ILabels } from "libraries/interfaces/ILabels";
import { WORDING } from "app_locobook/searchFlightForm/config/wording";
import { ExternalRedirectionService } from "app_locobook/service/external-redirection.service";
import { PriceSwitcherService } from "libraries/component/tab-navigation/price-switcher.service";
import { DateService } from 'libraries/date/date.service';
import { IAirSilentBookingRequest } from "libraries/service/resources/model/booking/air/IAirSilentBookingRequest";
import { IAirSearchRequest } from './air-search/air-search.component';
import { ExternalApplicationService } from './service/external-application/external-application.service';
import { IGetAirTripQuotes } from "libraries/service/resources/airTrip/IGetAirTripQuotes";
import { AirSearchResourceService } from "libraries/service/resources/air-search-resource/air-search-resource.service";
import { EWayType } from './air-search/air-search-form/air-search-segment-multiple/air-search-segment-multiple.component';

declare const wenji: IWenji;

const DEFAULT_SHOW_QUOTES: boolean = wenji.locobook && wenji.locobook.search ? wenji.locobook.search.results === SearchResultOption.list : false;

interface IFlexibilityDates {
    value: number;
    label: string;
}

class ComponentWording {
    public readonly itineraire: string = Yii.t('wui-iqba-js', 'Proposition sélectionnée');
    public readonly voyageurs: string = Yii.t('wui-iqba-js', 'Voyageurs');
    public readonly ssr: string = Yii.t('wui-iqba-js', 'Services spéciaux');
    public readonly rechercher: string = Yii.t('wui-iqba-js', 'Rechercher');
    public readonly resumeRecherche: string = Yii.t('wui-iqba-js', 'Résumé de la recherche');
    public readonly rechercheencours: string = Yii.t('wui-iqba-js', 'Recherche des vols en cours...');
    public readonly origineAller: string = Yii.t('wui-iqba-js', 'Origine (Aller)');
    public readonly origineRetour: string = Yii.t('wui-iqba-js', 'Origine (Retour)');
    public readonly destinationAller: string = Yii.t('wui-iqba-js', 'Destination (Aller)');
    public readonly destinationRetour: string = Yii.t('wui-iqba-js', 'Destination (Retour)');
    public readonly departAller: string = Yii.t('wui-iqba-js', 'Départ (Aller)');
    public readonly departRetour: string = Yii.t('wui-iqba-js', 'Départ (Retour)');
    public readonly cieexclusives: string = Yii.t('wui-iqba-js', 'Cies exclusives');
    public readonly ciepreferees: string = Yii.t('wui-iqba-js', 'Cies preférées');
    public readonly prixrefeadulte: string = Yii.t('wui-iqba-js', 'Prix de référence Adulte');
    public readonly tolerance: string = Yii.t('wui-iqba-js', 'Tolérance');
    public readonly detailVols: string = Yii.t('wui-iqba-js', 'Détails des vols');
    public readonly autresVols: string = Yii.t('wui-iqba-js', 'Tous les vols');
    public readonly ajouterDemande: string = Yii.t('wui-iqba-js', 'Ajouter une demande');
    public readonly fermerDemande: string = Yii.t('wui-iqba-js', 'Fermer');
    public readonly reserverVoyage: string = Yii.t('wui-iqba-js', 'Réserver le voyage');
    public readonly retour: string = Yii.t('wui-iqba-js', 'Retour');
    public readonly choisi: string = Yii.t('wui-iqba-js', 'Choisi');
    public readonly choisir: string = Yii.t('wui-iqba-js', 'Choisir');
    public readonly autresPropositions: string = Yii.t('wui-iqba-js', 'Toutes les propositions');
    public readonly saveAnOffer: string = Yii.t('wui-iqba-js', 'Sauvegarde d\'une offre');
    public readonly selectionnerProposition: string = Yii.t('wui-iqba-js', 'Sélectionner cette proposition');
    public readonly propositions: string = Yii.t('wui-iqba-js', 'propositions');
    public readonly nouvelleRecherche: string = Yii.t('wui-iqba-js', 'Nouvelle recherche');
    public readonly ajouterVoyageur: string = Yii.t('wui-iqba-js', 'Ajouter voyageurs');
    public readonly horairesDeparts: string = Yii.t('wui-iqba-js', 'Horaires des départs');
    public readonly horairesArrivees: string = Yii.t('wui-iqba-js', 'Horaires des arrivées');
    public readonly durrees: string = Yii.t('wui-iqba-js', 'Durées');
    public readonly durreesEscales: string = Yii.t('wui-iqba-js', 'Durées des escales');
    public readonly tarifsADT: string = Yii.t('wui-iqba-js', 'Tarifs par ADT');
    public readonly compagnies: string = Yii.t('wui-iqba-js', 'Compagnies');
    public readonly fareType: string = Yii.t('wui-iqba-js', 'FareType');
    public readonly message_aucunePropal: string = Yii.t('wui-iqba-js', 'Aucune Proposition ne correspond à vos critères.');
    public readonly formattexte: string = Yii.t('wui-iqba-js', 'Itinéraire Format Texte');
    public readonly formathtml: string = Yii.t('wui-iqba-js', 'Itinéraire Format HTML');
    public readonly textecopie: string = Yii.t('wui-iqba-js', 'Texte copié');
    public readonly notes: string = Yii.t('wui-iqba-js', 'Notes');
    public readonly backToWTB: string = Yii.t('wui-iqba-js', 'Retour à Watabi');
    public readonly backToSasha: string = Yii.t('wui-iqba-js', 'Retour à Sasha');
    public readonly gqaLoading: string = Yii.t('wui-iqba-js', "Chargement de l'offre séletionnée en cours");
    public readonly showAlternativeFares: string = Yii.t('wui-iqba-js', "Autres offres");
    public readonly hideAlternativeFares: string = Yii.t('wui-iqba-js', "Masquer les autres offres");
    public readonly saveOfferRequestCreation: string = Yii.t('wui-iqba-js', "Assemblage de l'offre à sauvegarder en cours");
    public readonly saveOfferWaiting: string = Yii.t('wui-iqba-js', "Sauvegarde de l'offre en cours");
    public readonly silentBooking: string = Yii.t('wui-iqba-js', "Réservation de l\'offre en cours");
    public readonly silentBookingWarning: string = Yii.t('wui-iqba-js', "L'offre sauvegardée a expiré. Veuillez effectuer une nouvelle recherche.");
    public readonly silentBookingSuccess: string = Yii.t('wui-iqba-js', "La réservation a été effectuée avec succès.");
    public readonly saveBestOfferWaiting: string = Yii.t('wui-iqba-js', "Sauvegarde de la meilleure offre en cours");
    public readonly servicesAnnexes: string = Yii.t('wui-iqba-js', 'Services annexes');
    public readonly modifySegmentButtonLabel: string = Yii.t('wui-iqba-js', "Ajouter à l'itinéraire");
    public readonly isItineraryChangeInformationLoaderMessage: string = Yii.t('wui-iqba-js', 'Chargement du dossier');
    public readonly priceChangesForLcc: string = Yii.t('wui-iqba-js', 'Le prix total de l\'offre a changé. La modification peut être due à des frais de paiement, à des frais appliqués pour les bébés, ou à des réductions (Low Cost Carriers).');
    public readonly offerGotten: string = Yii.t('wui-iqba-js', 'Offre récupérée');
    public readonly offerGetLoading: string = Yii.t('wui-iqba-js', 'Récupération et validation de l\'offre sauvegardée');
    public readonly priceChanges: string = Yii.t('wui-iqba-js', 'Le prix de la cotation a changé.');
    public readonly incorrectHost: string = Yii.t('wui-iqba-js', 'Les sources fournies pour la recherche ne sont pas disponibles pour ces critères, veuillez modifier vos critères.');
}

@Component({
    selector: 'search-app',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    styles: [`
        booking ::ng-deep dt-price {
            margin-right: .75rem;
        }

        h1 strong {
            font-weight: 600;
        }
    `]
})
export class SearchComponent implements OnInit, OnDestroy {

    public iconCaret: IconDefinition = faCaretRight;
    public showQuotes: boolean = DEFAULT_SHOW_QUOTES;
    public previousUrl: string;
    public showPNRForm: boolean = false;
    public Yii = Yii;
    public showCriteres: boolean = false;
    public isAlternativeFaresVisible: boolean = false;
    public propalResponse: any;
    public pnrResponse: any;
    public travellerResponse: any;
    public quoteResponse: any;
    public segmentList: object[];
    public ADTPrice: any;
    public hideModalFlights = true;
    public show = false;
    public showSSR = false;
    public post: any;
    public ssrResponse: any;
    public travellerList: string[];
    public selectedSegments: string[];
    public travellerDetails: boolean = false;
    public travellerFormList: any[] = [];
    public travellerForm: boolean = false;
    public isTravellerFormValid: boolean = false;
    public bookingClicked: boolean;
    // True if the page request is a post
    public isPost: boolean = true;
    public selectedJourney: string[];
    public search = false;
    public lsPrefix = sessionStorage.getItem("$instance_url");
    public workflowCode: string;
    //translation Yii
    public readonly wording: ComponentWording = new ComponentWording();
    public readonly notepadEditorPermission: string = NOTEPAD_EDITOR_PERMISSION;
    public segment: any;
    public traveller: any = [];
    public travellerFormData: any = [];
    public carrier: any;
    public locator: string;
    public fullServiceCarriersOnly: boolean;
    public cabin: string;
    public price: any;
    public quantity: any;
    public keyword: any;
    public priceStillValid: boolean = true;
    // flag to know when we got all data to show booking
    public loaded = false;
    //params container
    public params: any;
    //when url parsed
    public idSearch: string;
    public idQuote: string;
    public searchFormUse: boolean = false;
    public bookingSaveOffer: boolean = false;
    public showFlightForm: boolean = true;
    public searchSent: boolean = false;
    public canCreatePNR: boolean = false;
    public travellerName: { firstName: string, lastName: string };
    //Bread Crumb Items from servcei
    public bcItems: any = [];
    public bcProvisionalItems: any = {};
    public searchPage: boolean = true;
    public travellerPage: boolean = false;
    public toggleFlexibilityMenu: boolean = false;
    public hasSelectedFlexibility: boolean = false;
    public flexibilityLabel: string = Yii.t('wui-iqba-js', 'Flexibilité des départs');
    public flexibilityItems: Array<{ label: string; value: number }> = [];
    public flexibilityDateItems: Array<{ label: string; value: number }> = [];
    // Calculated dates list from the root date.
    public flexibilityDynamicsItems: Array<{ label: string; value: number }> = [];
    public flexibility;
    public host: string;
    public selectedFareFamilyXId: string;
    public originalRequest: any;
    public showFlightDetails: boolean[] = [];
    public searchErrorMessage?: string;
    public loader: {
        active: boolean;
        message: string;
    } = {
        active: false,
        message: null
    };
    public pnrCreationError: {
        active: boolean;
        message: string;
        technicalMessage: string;
    };
    public saveOfferError: string;
    public saveOfferId: string;
    public savingOffer: {
        show: boolean,
        done: boolean,
        error: {
            active: boolean,
            message: string
        },
        warning: {
            active: boolean,
            message: string
        }
    } = {
        show: false,
        done: false,
        error: {
            active: false,
            message: null
        },
        warning: {
            active: false,
            message: null
        }
    };
    public loadingOffer: {
        show: boolean,
        done: boolean,
        error: {
            active: boolean,
            message: string
        },
        warning: {
            active: boolean,
            message: string
        }
    } = {
        show: false,
        done: false,
        error: {
            active: false,
            message: null
        },
        warning: {
            active: false,
            message: null
        }
    };
    public silentBook: {
        show: boolean,
        done: boolean,
        error: {
            active: boolean,
            message: string
        },
        warning: boolean,
        success: boolean
    } = {
        show: false,
        done: false,
        error: {
            active: false,
            message: null
        },
        warning: false,
        success: false
    };
    public notificationType: typeof NotificationType = NotificationType;
    public journeysModalContent: any = {};
    public notes: IRemark[] = [];
    public isNotepadPermission: boolean;
    // showTravellerForm depending of the Id of requested traveller
    public travellerFormActiv: string;
    public navigationOrigin: IExternalApplicationData;
    public quoteSelectedJourneys: string[];
    public containerWidth: string;
    public dictionaryRoutesHostsErrorMessage: string = null;
    //DOM element
    @ViewChild('sectorsModal')
    public sectorsModal: any;
    @ViewChild('quotesModal')
    public quotesModal: any;
    @ViewChild('travellerFormTemplate')
    public travellerFormTemplate: TravellerFormComponent;
    @ViewChild('journeysModal')
    public journeysModal: any;
    @ViewChild('bookingComponent')
    public bookingComponent: BookingComponent;
    @ViewChild('notepadComponent')
    public notepadComponent: NotepadComponent;
    @ViewChild('searchFlightForm')
    public searchFlightForm: SearchFlightFormComponent;
    @ViewChild('bookingContainer')
    public bookingContainer: ElementRef;

    //public updatedBookingFlightPrices: IPrice[];
    public sessionPostOnUpdateBooking: any = null;
    public offerAlternativesPermission: string = 'iqba.quote.offer.alternatives.use';
    public vccPermission: boolean;
    public showNDCBook: boolean;
    public showLowcostBook: boolean;
    public modifySegmentPermission: boolean;
    public skipVccConfirmationPermission: boolean;
    public isShowAncillaryServices: boolean;
    public ancillaryServicesNotification: INotification = {
        message: Yii.t('wui-shared-js', 'Aucun service disponible sur cette offre.'),
        type: NotificationType.Warning,
        active: false,
    };
    public serviceSelection: any;
    public seatMapResponse: any;
    public isShowAncillaryServicesSelection: boolean;
    public actualFareFamily: IFareFamily;
    public segmentsForServices: IAirCreateBookingRequestSegment;

    public missingPermission: boolean = false;
    public contextIsModifySegment: boolean = false;
    public itineraryChangeInformation: IGetBookingsAirResponse;
    public isItineraryChangeInformationLoader: boolean = false;
    public itineraryChangeInformationError: INotification = {
        type: NotificationType.Error,
        active: false,
    };
    public selectSectorMatchFolder: ISectorSimile;
    public addPrice: { cost: number, retail: number };
    public airPermissions: typeof EAirBookingPermissions = EAirBookingPermissions;
    public isUseServices: boolean = true;
    public showServicesContent: boolean = true;
    public rightsGotten: boolean = false;
    public bookingWithSelection: any = undefined;
    public isFromWatabi: boolean = false;
    public searchFlightFormWording: ILabels = WORDING;
    public isGetOfferContext: boolean = false;
    public onOfferSelectedExternalLink: IBookingExternalLink;
    private subscription: Subscription;
    private subscription2: Subscription;
    private travellerCloseSubscription: Subscription;
    private viewSubscription: Subscription;
    private rightsSubscription: Subscription;
    private quoteHasLcc: boolean;
    private postWatabi: any = null;
    private applicationData: IExternalApplicationData = null;
    private savedOfferLoaded?: any;
    private airSearchRequest: IAirSearchRequest;
    private getHostAvailableSubscription: Subscription;
    private getPropalDataSubscription: Subscription;

    constructor(
        private readonly location: Location,
        private readonly authLocobookService: AuthLocobookService,
        private readonly segmentService: SegmentService,
        private readonly travellerService: TravellerService,
        private readonly carrierService: CarrierService,
        private readonly propalService: PropalService,
        private readonly silentBookingService: SilentBookingService,
        private readonly priceService: PriceService,
        private readonly quoteService: QuoteService,
        private readonly ssrService: SSRService,
        private readonly pnrService: PNRService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly rights: RightsService,
        private readonly viewService: ViewService,
        private readonly formBuilderService: FormBuilderService,
        private readonly breadcrumbIqba: BreadcrumbIqbaService,
        public dialog: MatDialog,
        private readonly samResourceService: SamResourceService,
        private readonly cacheSamResourceService: CacheSamResourceService,
        public readonly lowCostCompanyService: LowCostCompanyService,
        private readonly errorTracingService: ErrorTracingService,
        private readonly permissionResource: PermissionResourceService,
        private readonly createBookingWarningMessageService: CreateBookingWarningMessageService,
        private readonly cacheQuotedAvailabilityService: CacheQuotedAvailabilityService,
        private readonly quotedAvailabilityService: QuotedAvailabilityService,
        private readonly actionQualityHelperService: ActionQualityHelperService,
        private readonly airQuoteMappingService: AirQuoteMappingService,
        private readonly offerService: OfferService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly airBookingResourceService: AirBookingResourceService,
        private readonly apiResourceService: ApiResourceService,
        private readonly bookingCbCacheService: BookingCbCacheService,
        private readonly airBookingConditionApplyService: AirBookingConditionApplyService,
        private readonly externalRedirectionService: ExternalRedirectionService,
        protected readonly dictionaryRoutesHostsService: DictionaryRoutesHostsResourceService,
        private readonly priceSwitcherService: PriceSwitcherService,
        private readonly externalApplicationService: ExternalApplicationService,
        private readonly airSearchResourceService : AirSearchResourceService,
        private readonly dateService: DateService,
    ) {
        this.propalResponse = propalService.propalResponse;
        this.pnrResponse = pnrService.response;
        this.travellerResponse = travellerService.response;
        this.quoteResponse = quoteService.response;
        this.ssrService.getSSRList();
        this.ssrResponse = this.ssrService.response;
        this.bcItems = breadcrumbIqba.items;
        this.bcProvisionalItems = breadcrumbIqba.provisionalItems;
        this.rights.display.root = "iqba";
        this.viewService.display.root = "iqba";
        router.events.pipe(
            filter((event: any) => event instanceof NavigationStart))
            .subscribe((e: any) => {

                if (!this.propalResponse.lastPage) {
                    this.propalResponse.lastPage = "";
                }
                if (!this.propalResponse.history) {
                    this.propalResponse.history = [];
                }
                this.previousUrl = this.propalResponse.lastPage;
                if (e.url) {
                    this.propalResponse.lastPage = e.url;
                    this.propalResponse.history.push(e.url);
                }
            });

    }

    public ngOnInit(): void {
        const externalApplicationData = sessionStorage.getItem('IQBA_ExternalApplicationData');
        if (externalApplicationData) {
            this.applicationData = JSON.parse(externalApplicationData);
            this.isFromWatabi = this.applicationData?.application === 'watabi';
        }
        const post = sessionStorage.getItem('$post');
        if (post) {
            // set post on property to remove it in session storage
            this.sessionPostOnUpdateBooking = JSON.parse(post);
            this.priceSwitcherService.showPriceSwitcher(Boolean(this.sessionPostOnUpdateBooking?.price?.retail || this.sessionPostOnUpdateBooking?.price?.retailArray?.length ))
        }else{
            this.priceSwitcherService.showPriceSwitcher(false);
        }
        const autoLaunchPNRSearch: string = sessionStorage.getItem('autoLaunchPNRSearch');
        const autoLaunchPNRSearchOnLanding: boolean = !this.isFromWatabi && !((autoLaunchPNRSearch && autoLaunchPNRSearch === 'false') || (this.sessionPostOnUpdateBooking?.booking?.syscode));

        // save post cause lost in treatment and clean sessionStorage
        if (this.isFromWatabi) {
            this.postWatabi = JSON.parse(post);
            this.cleanSessionStorageFromWatabi();
        }
        this.getNavigationOrigin();

        // WARNING : useless here without Observable
        // rightsGotten to suppress issue
        this.initRights();

        //determine if back from pnr page
        if (this.breadcrumbIqba.getPnrPageParameters() && this.propalResponse.searchRQ && autoLaunchPNRSearchOnLanding) {
            this.canCreatePNR = true;
            this.searchSent = true;
            this.post = this.propalResponse.searchRQ;
            this.getInfos(this.propalResponse.searchRQ, true);
            this.showQuotes = this.breadcrumbIqba.getShowQuotes();
        }

        if (!this.breadcrumbIqba.getPnrPageParameters() && this.propalResponse.searchRQ) {
            this.getInfos(this.propalResponse.searchRQ);
        }

        if (this.propalResponse.traveller && Object.keys(this.propalResponse.traveller).length > 0) {
            this.validTraveller(this.propalResponse.traveller);
        }

        if (this.sessionPostOnUpdateBooking && this.sessionPostOnUpdateBooking.permission?.services) {
            const permissionServices = this.sessionPostOnUpdateBooking.permission.services;

            if (permissionServices.hasOwnProperty('use') && permissionServices.use !== this.isUseServices) {
                this.isUseServices = permissionServices.use;
            }

            if (permissionServices.hasOwnProperty('show') && permissionServices.show !== this.showServicesContent) {
                this.showServicesContent = permissionServices.show;
            }
        }

        if (this.sessionPostOnUpdateBooking?.booking?.syscode &&
            this.sessionPostOnUpdateBooking?.booking?.code &&
            this.sessionPostOnUpdateBooking?.booking?.host &&
            this.sessionPostOnUpdateBooking?.booking?.owner) {
            this.permissionResource.hasPermission("shared.air.booking.segment.modify").subscribe({
                next: (isPermitted: boolean): void => {
                    this.modifySegmentPermission = isPermitted;
                    if (isPermitted) {
                        this.contextIsModifySegment = true;
                        this.getBooking();
                    } else {
                        this.handleMissingPermission();
                    }
                }
            });
        } else {
            this.searchAction(autoLaunchPNRSearchOnLanding);
        }

        if (!this.sessionPostOnUpdateBooking) {
            // #13257 : if not $post (means no required datas) , disable "CREATE" btn
            this.isPost = false;
        } else {
            this.workflowCode = this.sessionPostOnUpdateBooking.workflow?.code;
        }
        this.infoSubscription();
        this.submitNamedFormSubscription();
        this.closeNamedFormSubscription();
        this.initBreadcrumb();
    }

    public setRoutHostMessage(message: string): void {
        this.dictionaryRoutesHostsErrorMessage = message;
        this.searchSent = false;
    }

    public get hasAlternativeFares(): boolean {
        return Boolean(
            this.propalResponse.data?.selectedQuote?.fareFamily &&
            Object.values(this.propalResponse.data?.selectedQuote?.fareFamily).length &&
            (Object.values(this.propalResponse.data?.selectedQuote?.fareFamily)[0] as IFareFamily).xId);
    }

    public toggleAlternativeFares(event: Event): void {
        event.stopPropagation();
        if (this.serviceSelection) {
            this.openConfirmRemoveServices();
        } else {
            this.toggleAlternativeFaresAction();
        }

    }

    public toggleAlternativeFaresAction(): void {
        const ratingArray = this.propalResponse.data.booking[this.propalResponse.display.booking].ratingArray;
        const journeyKey = Object.keys(this.propalResponse.data.selectedQuote.segment).map((selectedSegment) => {
            return this.propalResponse.data.selectedQuote.segment[selectedSegment].journey[0];
        });
        ratingArray?.push({...ratingArray[0], journeyKey: journeyKey?.join('-')});
        this.propalResponse.data.booking[this.propalResponse.display.booking] = {
            ...this.propalResponse.data.selectedQuote,
            ratingArray
        };
        this.selectedSegments = Object.keys(this.propalResponse.data.selectedQuote.segment);
        this.containerWidth = `${this.bookingContainer?.nativeElement?.offsetWidth}px`;
        this.isAlternativeFaresVisible = !this.isAlternativeFaresVisible;
    }

    public openConfirmRemoveServices(): void {
        const data: IConfirmDialogData = {
            title: Yii.t('wui-sasha-js', 'Des services sont sélectionnés'),
            question: Yii.t('wui-sasha-js', 'Voulez-vous supprimer les services ?'),
            cancel: Yii.t('wui-sasha-js', 'Annuler'),
            accept: Yii.t('wui-sasha-js', 'Confirmer'),
        };
        const dialogRef: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, {
            width: '650px',
            disableClose: true,
            data
        });
        dialogRef.afterClosed()
            .subscribe((result: string): void => {
                if (result === 'process') {
                    this.resetServiceSelection();
                    this.toggleAlternativeFaresAction();
                }
            });
    }

    public getSearchRequest() {
        // Get request to inject in the form
        return this.airSearchResourceService
            .getSearchRequest(this.propalService.propalResponse.data.key)
            .pipe(
                tap((request) => {
                    this.priceSwitcherService.showPriceSwitcher(Boolean(request.body?.price?.retail || request.body?.price?.retailArray?.length));

                    this.originalRequest = request;
                    this.propalService.propalResponse.searchRQ = request;
                    //#18502 : search abstract datas
                    this.segment = this.segmentService.getSegment(request.body);
                    this.carrier = this.carrierService.getCarrier(request.body);
                    this.price = this.priceService.getPrice(request.body);

                    if (request.body.locator) {
                        this.locator = request.body.locator;
                    }

                    this.quantity = request.body.quantity ?
                        request.body.quantity :
                        this.travellerService.getQuantityFromTraveller(request.body.traveller);
                    this.keyword = request.body.keyword;

                    this.fullServiceCarriersOnly = request.body.fullServiceCarriersOnly;

                    this.propalResponse.traveller = this.travellerService.getTraveller(request.body);

                    this.flexibility = _get(request.body, 'flexibility');
                    request.body.host = Array.isArray(request.body.host) ?
                        request.body.host :
                        [request.body.host];
                    this.host = request.body.host;
                    const rqCopy = _cloneDeep(request.body);
                    this.post = rqCopy;
                    this.loaded = true;

                    this.computeSearchFormUse(request.body.permission);
                    this.computeBookingSaveOffer(request.body.permission);
                })
            );
    }

    public loadPropositionsWithFlexibility(flexibility: { label: string; value: number }): void {
        this.hasSelectedFlexibility = true;
        this.toggleFlexibilityMenu = false;
        this.flexibilityLabel = flexibility.label;

        this.propalResponse.appliedFilter = Object.keys(this.getFilterData()
            .beginPlusOrMinus).filter((date: any) => date.daysDifference === flexibility);
    }

    public getFlexibilityOptions(flexibility: number): IFlexibilityDates[] | void {
        // #TODO sortir le JSON.parse dans une fonction générique
        const momentFormat = JSON.parse(wenji.ui.dateFormat).momentMediumNoYear;

        const beginPlusOrMinus: {
            daysDifference: number;
            quantity: 15;
            quotes: string[];
        } = this.getFilterData().beginPlusOrMinus;

        const dates: IFlexibilityDates[] = Object.keys(beginPlusOrMinus).map((date: string) => {
            return {
                value: beginPlusOrMinus[date].daysDifference,
                label: moment(date).format(momentFormat)
                    + ' - '
                    + moment(date).add(beginPlusOrMinus[date].quantity, 'days')
                        .format(momentFormat)
            };
        });

        return dates;
    }

    public login(): void {
        this.authLocobookService.getXsecurity();
    }

    public getFilterData(): any {
        return this.quoteService.response.data.filter;
    }

    public getAppliedFilter(): any {
        return this.quoteService.response.appliedFilter;
    }

    /*
    * Choose a journey form journeys list
    */
    public chooseJourney(selectedSegment: string[], bookingKey: string, fromQuotes: boolean = false): void {
        if (bookingKey === this.propalResponse.display.booking) {
            //if from search page
            this.propalResponse.display.selectedJourneys = selectedSegment;
        }
        if (fromQuotes) {
            //if from Quotes Modal
            this.initQuotesSectorsDisplay(bookingKey);

            this.quoteResponse.display.selectedJourneys[bookingKey] = selectedSegment;
            this.backToQuotes('journeysModal');
        }
        this.initQuoteHasLcc();
    }

    private getBooking() {
        this.isItineraryChangeInformationLoader = true;
        this.showFlightForm = false;
        this.airBookingResourceService.get(
            this.sessionPostOnUpdateBooking.booking.host,
            this.sessionPostOnUpdateBooking.booking.syscode,
            wenji.ui.target,
            false,
            this.sessionPostOnUpdateBooking.booking.owner).toPromise()
            .then((res: IGetBookingsAirResponse) => {
                this.isItineraryChangeInformationLoader = false;

                const isOneSectorLowCost: boolean = (res.sector as ISectorAir[])
                    .some((sector: ISectorAir): boolean => !sector.category || sector.category === 'lowcost');

                if (res.issueStatus === ApiIssueStatus.CompletelyIssued) {
                    this.itineraryChangeInformationError.active = true;
                    this.itineraryChangeInformationError.message = Yii.t('wui-iqba-js', "Ce dossier a déjà été émis, impossible d'y ajouter des segments.");
                } else if (isOneSectorLowCost) {
                    this.itineraryChangeInformationError.active = true;
                    this.itineraryChangeInformationError.message = Yii.t('wui-iqba-js', "Ce dossier contient des segments lowcost, impossible d'y ajouter des segments.");
                } else {
                    this.itineraryChangeInformationError.active = false;
                    this.itineraryChangeInformation = res;
                    this.showFlightForm = true;
                    this.setTravellers(this.itineraryChangeInformation);
                    if (this.showServicesContent && this.itineraryChangeInformation.service?.length > 0) {
                        this.airBookingResourceService.getWithServiceSelection(this.sessionPostOnUpdateBooking.booking.host, this.sessionPostOnUpdateBooking.booking.syscode, wenji.ui.target).toPromise()
                            .then((response: any) => {
                                this.bookingWithSelection = response;
                            });
                    }
                    this.searchAction(false);
                }
            }).catch((e) => {
            this.itineraryChangeInformationError.active = true;
            this.itineraryChangeInformationError.message = e.message;
            this.isItineraryChangeInformationLoader = false;
        });
    }

    private getSavedOffer(): void {
        this.isGetOfferContext = true;
        this.searchFormUse = false;

        const request: IAirApplicationAutomatorRequest = {
            content: this.sessionPostOnUpdateBooking
        };

        this.offerService.getSavedOffer(request, wenji.ui.target).subscribe({
            next: (response: any): void => {
                // TODO+LA : response.data TO response as API send response.data under parent response.data
                if (response === null || (response.warningMessage && response.warningMessage.length > 0) || response.data === null) {
                    this.propalResponse.message = response ? response.message : "Erreur lors de la récupération et la validation de l'offre voulue.";
                    return;
                }

                this.savedOfferLoaded = response.data;

                const mappedResponse: { quote: IAirQuotedAvailabilityResponse, booking: any }
                    = this.offerService.buildGetRequest(response.data);

                this.propalService.storeResult(mappedResponse.booking);
                this.propalService.storeQuote(mappedResponse.booking);
                this.propalService.storeSelectedQuote(mappedResponse.quote);

                this.showPNRForm = true;
                this.setTravellers(this.sessionPostOnUpdateBooking);

                this.loaded = true;
                this.loader.active = false;
            },
            error: (error: ResourceError): void => {
                this.errorTracingService.captureException(error);
                this.loader.active = false;
                this.propalResponse.message = error.message;
            }

        });
    }

    private searchAction(autoLaunchPNRSearchOnLanding: boolean) {
        const parameters: Params = this.route.snapshot.params;
        this.idSearch = parameters.idSearch || null;
        if (parameters.hasOwnProperty('idAlternative')) {
            this.getAlternativeOnLanding(parameters);
        } else if (parameters.hasOwnProperty('idSearch') && parameters.hasOwnProperty('idQuote')) {
            this.searchOnLandingWithExistingSearchId(parameters);
        } else if (this.sessionPostOnUpdateBooking && !parameters.idSearch) {
            this.searchOnLandingWithSessionStorageSearchArguments(autoLaunchPNRSearchOnLanding);
        }
    }

    public ngOnDestroy(): void {
        this.viewSubscription.unsubscribe();
        this.subscription.unsubscribe();
        this.subscription2.unsubscribe();
        this.rightsSubscription.unsubscribe();
        this.travellerCloseSubscription.unsubscribe();
        if (this.getHostAvailableSubscription) {
            this.getHostAvailableSubscription.unsubscribe();
        }
        if (this.getPropalDataSubscription) {
            this.getPropalDataSubscription.unsubscribe();
        }
        this.sessionPostOnUpdateBooking = null;
    }

    public getTravellers() {
        return Object.keys(this.propalResponse.traveller)
            .map((key: string, i) => {
                const title: string = this.propalResponse.traveller[key].title ?
                    this.propalResponse.traveller[key].title.toLowerCase() === 'mrs' ? 'Ms' : this.propalResponse.traveller[key].title :
                    'Mr';
                return {
                    ...this.propalResponse.traveller[key],
                    title,
                    type: this.propalResponse.traveller[key].type ? this.propalResponse.traveller[key].type : 'Adult',
                };
            });
    }

    public setTravellers(travellers): void {
        this.propalResponse.traveller = this.travellerService.getTraveller(travellers);
        this.validTraveller(this.propalResponse.traveller);
    }

    public getTravellerFormValidity(): void {
        if (this.travellerFormTemplate) {
            this.travellerFormTemplate.submitForm();
        }
    }

    public checkTravellersFormValidity(isValid: boolean): void {
        this.isTravellerFormValid = isValid;
    }

    public selectAlternative({quoteId, quote, offerAlternativePriceXId, fareFamilyXId}: IOnAlternativeSelectOutput): void {
        this.showQuotes = false;

        const mappedQuote: IAirQuotedAvailabilityResponse = this.airQuoteMappingService
            .mapGqaNewToOld(quote, offerAlternativePriceXId) as unknown as IAirQuotedAvailabilityResponse;

        this.propalService.storeSelectedQuote(mappedQuote, quoteId);
        this.selectedFareFamilyXId = fareFamilyXId;
        this.compactSelectBookingData();
    }

    /*
    * Choose all the quotes to display in quotes modal
    */
    public getQuotes(): void {
        if (!this.quoteResponse.data.booking) {
            this.quoteService.key = this.propalService.propalResponse.data.key;
            this.quoteService.getQuotes();
        }
    }

    public selectQuote(event: IOutSelectQuote): void {
        const bookingKey: string = event.quoteId;
        const selectedJourneys: string[] = event.selectedJourneys;

        this.loader = {
            active: true,
            message: 'Actualisation en cours'
        };
        this.propalResponse.message = undefined;
        this.pnrCreationError = undefined;
        this.showPNRForm = false;
        if (!this.propalService.propalResponse?.data?.booking[bookingKey]) {
            this.propalService.getPropalWithKeys(this.propalService.propalResponse.data.key, bookingKey).pipe(
                tap((quote: any): void => {
                    this.propalService.storeQuote(quote.booking);
                    this.propalService.selectQuote(quote.booking, true, this.propalService.propalResponse?.data?.dictionary?.carrier);
                }),
                mergeMap((): Observable<any> => {
                    return this.getSearchRequest();
                }),
                mergeMap((): Observable<{ request: IAirGetQuotedAvailabilityRequest, response: IAirQuotedAvailabilityResponse }> => {
                    this.loader.message = Yii.t('wui-iqba-js', 'Vérification de la cotation auprès du GDS');
                    return this.sendGetQuotedAvailabilityRequest(bookingKey, selectedJourneys).pipe(
                        catchError((error: Error): Observable<{ response: IAirQuotedAvailabilityResponse, request: IAirGetQuotedAvailabilityRequest }> => {
                            console.error(error);
                            this.propalResponse.message = error.message;
                            this.loader.active = false;
                            this.priceStillValid = false;
                            throw new RuntimeError(error.message, error);
                        })
                    );
                }),
                tap(({response}: { request: IAirGetQuotedAvailabilityRequest, response: IAirQuotedAvailabilityResponse }): void => {
                    this.propalService.storeSelectedQuote(response);
                    // this.selectedFareFamilyXId = Object.keys(response.fareFamily)[0];
                    this.propalResponse.data.booking[this.propalResponse.display.booking] = response;
                    const booking: any = this.propalResponse.data.booking[this.propalResponse.display.booking];
                    this.compactSelectBookingData();
                    const sqaQuotePrice: number = this.pnrService.getCostPrice(booking);
                    const quoteAvailabilityPrice: number = this.pnrService.getCostPrice(response);
                    this.showPNRForm = true;
                    this.loader.active = false;
                    this.priceStillValid = true;
                    this.propalResponse.transactionId = response.transactionId;
                    this.propalService.propalResponse.display.selectedJourneys = selectedJourneys;
                    this.initQuoteHasLcc();

                    this.propalResponse.warningMessage =
                        quoteAvailabilityPrice !== sqaQuotePrice ?
                            this.quoteHasLcc ? this.wording.priceChangesForLcc : this.wording.priceChanges
                            : null;
                })
            ).subscribe();
        } else {
            const tempObj: any = {};
            tempObj[bookingKey] = this.propalService.propalResponse.data.booking[bookingKey];
            this.propalService.selectQuote(tempObj, true, this.propalService.propalResponse?.data?.dictionary?.carrier);
            this.propalService.propalResponse.display.selectedJourneys = selectedJourneys;
            this.initQuoteHasLcc();
            this.loader.message = Yii.t('wui-iqba-js', 'Vérification de la cotation auprès du GDS');

            this.getSearchRequest().pipe(
                mergeMap((param: any): Observable<{ request: IAirGetQuotedAvailabilityRequest, response: IAirQuotedAvailabilityResponse }> => {
                    return this.sendGetQuotedAvailabilityRequest(bookingKey, selectedJourneys).pipe(
                        catchError((error: Error): Observable<{ response: IAirQuotedAvailabilityResponse, request: IAirGetQuotedAvailabilityRequest }> => {
                            this.propalResponse.message = error.message;
                            this.loader.active = false;
                            this.priceStillValid = false;
                            throw new RuntimeError(error.message, error);
                        }),
                        tap(({response}
                                 : { request: IAirGetQuotedAvailabilityRequest, response: IAirQuotedAvailabilityResponse }) => {
                            this.propalService.storeSelectedQuote(response);
                            // this.selectedFareFamilyXId = Object.keys(response.fareFamily)[0];
                            const booking: any = this.propalResponse.data.booking[this.propalResponse.display.booking];
                            this.compactSelectBookingData();
                            const sqaQuotePrice = this.pnrService.getCostPrice(booking);
                            const quoteAvailabilityPrice = this.pnrService.getCostPrice(response);
                            this.showPNRForm = true;
                            this.loader.active = false;
                            this.priceStillValid = true;

                            this.propalResponse.warningMessage =
                                quoteAvailabilityPrice !== sqaQuotePrice ?
                                    this.quoteHasLcc ?
                                        this.wording.priceChangesForLcc : this.wording.priceChanges
                                    : null;
                            this.propalResponse.transactionId = response.transactionId;

                        })
                    );
                }),
                catchError((error: Error): Observable<{ response: IAirQuotedAvailabilityResponse, request: IAirGetQuotedAvailabilityRequest }> => {
                    this.propalResponse.message = error.message;
                    this.loader.active = false;
                    this.priceStillValid = false;
                    throw new RuntimeError(error.message, error);
            })
            ).subscribe();
        }
    }

    public compactSelectBookingData() {
        const selectBooking: any = this.propalResponse.data.selectedQuote;
        this.addPrice = this.priceService.getTotalPrice(selectBooking.total);
        let allSector: any[][] = [];
        Object.keys(selectBooking.segment).forEach((segmentKey: string): void => {
            const journeyId: string = selectBooking.segment[segmentKey].journey;
            const sector: any[] = selectBooking.segment[segmentKey][journeyId].sector;
            let shortSector: any[] = [];
            sector.forEach((sec, index: number): void => {
                const seatClass: string = Object.keys(sector[index].seat)[0];
                const aircraft = sec?.aircraft !== null ? sec.aircraft : null;
                let tmpSec: any = {
                    from: sec?.from,
                    to: sec?.to,
                    begin: sec?.begin,
                    carrier: sec?.carrier,
                    flight: sec?.flight,
                    aircraft: aircraft,
                    classe: seatClass
                };
                shortSector.push(tmpSec);
            });
            allSector.push(shortSector);
        });
        this.chekSector(allSector);
    }

    public chekSector(entrySector: any[][]) {
        this.selectSectorMatchFolder = {
            data: [],
            nbSameSector: 0,
            nbSameFlight: 0,
            diffPrice: this.itineraryChangeInformation?.total,
        };
        if (this.itineraryChangeInformation?.sector) {
            entrySector.forEach((table: any[], index: number): void => {
                table.forEach((sector): void => {
                    let boolSameFlight: boolean = false;
                    let boolSameSector: boolean = false;
                    for (const check of this.itineraryChangeInformation?.sector) {
                        if (sector.from === check.from.airport.code &&
                            sector.to === check.to.airport.code &&
                            sector.begin === check.begin &&
                            sector.carrier.code === check.carrier.code &&
                            sector.flight === check.flight) {
                            boolSameFlight = true;
                            this.selectSectorMatchFolder.nbSameFlight++;
                        }
                        if (boolSameFlight && sector.classe === check.seat.code) {
                            boolSameSector = true;
                            this.selectSectorMatchFolder.nbSameSector++;
                        }
                        if (boolSameFlight) {
                            break;
                        }
                    }
                    this.selectSectorMatchFolder.data.push({
                        sameFlight: boolSameFlight,
                        sameSector: boolSameSector,
                        index: index,
                    });
                });
            });
        }

    }

    /*
    * Action when click on "détail des vols"
    */
    public getQuote(bookingKey: string): void {
        this.showCriteres = false;

        if (!this.propalResponse.data.booking[bookingKey]) { //test if data exist, dont make transction if not needed
            this.propalService.getQuote(bookingKey);
        }
    }

    /*
    * select SSR hub :
    *  if action = select -> selecteSSR
    *  if action = unselect -> unselecteSSR
    */
    public selectSSRHub($event: any): void {

        // Get all travellers
        const travellers: any = this.travellerService.getTravellersList('ssr');

        // Get index from travellerItem to find traveller in array with index
        const getIndexFromTravellerItem: number = $event.travellerItem.substring('T_'.length) - 1;
        // Construct new object of properties we need
        this.travellerName = {
            firstName: travellers[getIndexFromTravellerItem].firstName,
            lastName: travellers[getIndexFromTravellerItem].lastName
        };

        if ($event.action === "select" || $event.action === "update") {
            this.selectSSR($event);
        } else if ($event.action === "unselect") {
            this.unselectSSR($event);
        }
    }

    public searchAgain() {
        this.submitSearch(this.airSearchRequest);
        this.priceStillValid = true;
    }

    /*
    * select SSR choosen in ssr component
    */
    public selectSSR($event: any): void {
        // Get all travellers
        const travellers: any = this.travellerService.getTravellersList('ssr');
        // Get index from travellerItem to find traveller in array with index
        const getIndexFromTravellerItem: number = $event.travellerItem.substring('T_'.length) - 1;

        // Construct new object of properties we need
        this.travellerName = {
            firstName: travellers[getIndexFromTravellerItem].firstName,
            lastName: travellers[getIndexFromTravellerItem].lastName
        };

        this.ssrService.selectSSR($event.travellerItem, $event.ssrkey, $event.textValue);
    }

    /*
    * unselect SSR choosen in ssr component
    */
    public unselectSSR($event: any): void {
        this.ssrService.unselectSSR($event.travellerItem, $event.ssrkey);
    }

    public showBookButtons(): boolean {
        let showBook: boolean = true;
        if (this.sessionPostOnUpdateBooking?.permission?.booking?.create) {
            showBook = this.sessionPostOnUpdateBooking?.permission?.booking?.create !== false;
        }
        const canBeBooked: boolean = this.offerCanBeBooked();
        return !canBeBooked ? canBeBooked : this.quoteHasLcc ? (this.vccPermission && wenji.locobook.vcc) : showBook;
    }


    /*
    * Checking = is lowcost => open confirmation modal when needed or createService()
    *            is not lowcost => createService()
    */
    public handleBooking(): void {
        const isLowcost = this.lowCostCompanyService.hasLcc(
                this.propalResponse.data.booking[this.propalResponse.display.booking],
                this.propalResponse.display.selectedJourneys) &&
            this.offerCanBeBooked();
        if (isLowcost && wenji.locobook.vcc && this.vccPermission) {
            if (!this.skipVccConfirmationPermission) {
                this.confirmBooking();
            } else {
                this.createService();
            }
        } else if (!isLowcost) {
            this.createService();
        }
    }

    public updateBooking(): void {
        this.loader = {
            active: true,
            message: Yii.t('wui-iqba-js', 'Mis à jour du dossier en cours')
        };
        this.itineraryChangeInformation.syscode = this.normalizeSyscode(this.itineraryChangeInformation.syscode);
        const body: IAirUpdateBookingRequest = this.pnrService.buildUpdateRequest(this.itineraryChangeInformation, this.propalResponse.data.selectedQuote);
        this.airBookingResourceService.update(this.itineraryChangeInformation.syscode, body).toPromise()
            .then((booking: any): void => {
                this.loader.active = false;
                this.createBookingWarningMessageService.setWarningMessage(booking.warningMessage);
                if(booking.response?.payment){
                    this.createBookingWarningMessageService.setWarningNewPrice(booking.response.payment as IBookingErrorPriceChangedResponsePayment[]);
                }
                this.returnToSasha(this.itineraryChangeInformation.syscode);
            }).catch((error) => {
            this.errorTracingService.captureException(error);
            this.loader.active = false;
            this.pnrCreationError = {
                active: true,
                message: Yii.t(
                    'wui-iqba-js',
                    'Une erreur est survenue lors de la réservation.'
                ),
                technicalMessage: error.message
            };
        });
    }

    private normalizeSyscode(syscode: string) {
        const syscodeSplit: string[] = syscode.split(/(\d{4}-\d{2}-\d{2})/);
        return [syscodeSplit[0], syscodeSplit[1]].join('');
    }

    public confirmBooking(): void {
        const dialogData: IConfirmDialogData = {
            title: Yii.t("wui-quotation-js", "Confirmation de la réservation"),
            question: Yii.t("wui-quotation-js", "Voulez-vous réserver tout en utilisant une carte virtuelle ?"),
            accept: Yii.t("wui-shared-js", "Réserver"),
            cancel: Yii.t("wui-shared-js", "Annuler"),
        };

        const dialogRef: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, {
            autoFocus: true,
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'process') {
                this.createService();
            }
        });
    }

    /*
    * Create the RQ to create the pnr, then nav to pnr component
    */
    public createService(): void {
        if (!_find(this.bcItems, (o: any) => {
            return o.action.name === "pnrPage";
        })) {
            this.breadcrumbIqba.addPage(this.breadcrumbIqba.provisionalItems.pnrPage);
        }
        const userInfo = JSON.parse(sessionStorage.getItem("userInformations")); //TODO get user with a better way
        const userId: number = userInfo.sam_contact.id;
        const companyId: number = userInfo.sam_company;
        const note: INotepad[] = this.notepadComponent ? this.notepadComponent.extractNotes() : [];
        this.loader = {
            active: true,
            message: Yii.t('wui-iqba-js', 'Création du dossier en cours')
        };

        this.resetPnrCreationError();
        let sessionPostOnUpdateBooking: any = (this.sessionPostOnUpdateBooking || this.propalService.propalResponse.searchRQ || JSON.parse(sessionStorage.getItem('$post')));
        if (sessionPostOnUpdateBooking?.body) {
            sessionPostOnUpdateBooking = sessionPostOnUpdateBooking.body;
        }
        const onBookingCreatedNotificationArray: IOnBookingCreatedNotificationSetup[] = sessionPostOnUpdateBooking?.onBookingCreatedNotificationArray;

        const onOfferSelectedNotificationArray: IOnOfferSelectedNotificationSetup[] = sessionPostOnUpdateBooking?.onOfferSelectedNotificationArray;

        const onBookingCreationFailedNotificationArray: IOnBookingCreationFailedNotificationSetup[] = sessionPostOnUpdateBooking?.onBookingCreationFailedNotificationArray;

        const isLowCost: boolean = this.isLowCost();
        let vendor = null;
        let externalBooking: IAirExternalBooking = null;

        if (isLowCost) {
            vendor = this.propalResponse.data.booking[this.propalResponse.display.booking].vendor;
            externalBooking = sessionPostOnUpdateBooking?.externalBooking;
        }

        let samData: {
            samAgent: ISamAgent;
            samCompany: ISamCompany;
        };

        const urlParts: string[] = window.location.href
            .split('/search/')[1]
            .split('/');

        const fakeParams: Params = {
            idSearch: urlParts[0],
            idQuote: urlParts[1],
        };
        this.cacheSamResourceService.getAgentAndCompany(userId, companyId)
            .pipe(
                map(([samAgent, samCompany]: [ISamAgent, ISamCompany]): IAirCreateBookingRequest => {
                        samData = {samAgent, samCompany};
                        return this.pnrService.buildRequest(
                            this.isPerm('searchPage.travellerTile.edit'),
                            samAgent,
                            samCompany,
                            note,
                            onBookingCreatedNotificationArray,
                            onOfferSelectedNotificationArray,
                            onBookingCreationFailedNotificationArray,
                            isLowCost,
                            externalBooking,
                            vendor,
                            this.serviceSelection,
                        );
                    }
                ),
                mergeMap((originalRequest: IAirCreateBookingRequest): Observable<[IAirCreateBookingRequest, boolean]> => {
                    this.prepareDataForAncillaryServices();
                    return this.airBookingConditionApplyService.airCreateBookingRequestTestAndModify(
                        originalRequest,
                        // @ts-ignore
                        this.actualFareFamily,
                        this.segmentsForServices,
                        this.propalResponse.traveller,
                        isLowCost,
                    );
                }),
                // filter here because of request modification
                filter(([request, isLast ]: [IAirCreateBookingRequest, boolean]) => isLast),
                flatMap(([request, isLast ]: [IAirCreateBookingRequest, boolean]) => {
                        // try to simulate a change in price when CB
                        // if(request.payment){
                        //     request.payment.price.cost.currency = {
                        //         ... request.payment.price.cost.currency,
                        //         value:  request.payment.price.cost.currency.value - 5000,
                        //         amount:  (Number(request.payment.price.cost.currency.amount) - 50).toString(),
                        //     };
                        // }
                        return this.pnrService.createBooking(request).pipe(
                            catchError((error: Error): Observable<{ response: IGetBookingsAirResponse, display: IAirDisplay }> => {
                                throw new RuntimeError(error.message, error);
                            })
                        );
                    }
                ),
            )
            .subscribe({
                next: async (booking: { request: IAirCreateBookingRequest; response: IGetBookingsAirResponse; display: IAirDisplay; }): Promise<void> => {
                    this.loader.active = false;
                    this.createBookingWarningMessageService.setWarningMessage(booking.response.warningMessage);
                    this.createBookingWarningMessageService.setWarningNewPrice(booking.response.payment as IBookingErrorPriceChangedResponsePayment[]);
                    this.createBookingWarningMessageService.setWarningSqaRouteParams(
                        this.route.snapshot.params.idSearch ?
                            this.route.snapshot.params :
                            fakeParams
                    );
                    this.createBookingWarningMessageService.setWarningRequestPrice(booking.request);

                    if (booking.response.detailedWarningArray?.length) {
                        this.createBookingWarningMessageService.setWarningArray(booking.response.detailedWarningArray);
                        this.createBookingWarningMessageService.setCbNewRequestAfterPriceChanged(
                            booking.request,
                            booking.response as unknown as IBookingErrorPriceChangedResponse
                        );
                    }
                    this.bookingCbCacheService.storeCreateBookingResponse(booking.response.syscode, booking.response);
                    if (this.isFromWatabi && this.postWatabi.onBookingCreatedNotification) {
                        await this.updateWatabiPnr(booking.response).then(() => {
                            this.returnToWatabi(booking.response.code);
                        });
                    } else {
                        // #31672 reinit all service with propalResponse init in constructor cause service not reinit after comeback from create booking on IQBA but maybe someone missing
                        this.breadcrumbIqba.initBreadcrumbIqba();
                        this.cacheQuotedAvailabilityService.clearCache();
                        this.propalService.initPropalResponse();
                        this.quotedAvailabilityService.initPropalResponse();
                        this.pnrService.initPropalResponse();
                        this.propalResponse = this.propalService.propalResponse;
                        if (this.sessionPostOnUpdateBooking) {
                            sessionStorage.setItem("$post", JSON.stringify(this.sessionPostOnUpdateBooking));
                        }
                        this.router
                            .navigate(['locobook', 'hosts', booking.request.host, 'bookings', encodeURI(booking.response.syscode)])
                            .catch((reason: unknown) => {
                                this.errorTracingService.captureException(reason);
                            });
                    }
                },
                error: (error: ResourceError): void => {
                    this.errorTracingService.captureException(error);
                    this.loader.active = false;
                    this.pnrCreationError = {
                        active: true,
                        message: Yii.t(
                            'wui-iqba-js',
                            'Une erreur est survenue lors de la réservation.'
                        ),
                        technicalMessage: error.message
                    };
                }
            });
    }

    private async updateWatabiPnr(booking: IGetBookingsAirResponse): Promise<void> {
        const body: TExternalService = {
            idRoot: this.postWatabi.onBookingCreatedNotification.body.idRoot,
            idItem: this.postWatabi.onBookingCreatedNotification.body.idItem,
            category: this.postWatabi.onBookingCreatedNotification.body.category,
            isActive: true,
            hasChange: true,
            begin: booking.begin,
            end: booking.end,
            service: {
                booking,
                code: booking.code,
                cost: booking.total?.length ? [{
                    amount: booking.total[0].amount,
                    currency: booking.total[0].currency,
                    decimals: booking.total[0].decimals,
                    value: booking.total[0].value,
                    xType: booking.total[0].xType,
                }] : null,
                host: booking.host,
                showPrice: true
            },
            booking: {
                code: booking.code,
                host: booking.host,
                syscode: this.normalizeSyscode(booking.syscode)
            }
        };
        return this.apiResourceService.postOne<any, any>(this.postWatabi.onBookingCreatedNotification.url, body).toPromise();
    }

    public saveOffer(): void {
        this.resetSaveOffer();

        this.showFlightForm = false;
        this.showQuotes = false;
        this.savingOffer.show = true;

        this.loader.active = true;
        this.loader.message = this.wording.saveOfferRequestCreation;

        const saveOfferId: string = this.offerService.buildKey(
            this.propalService.propalResponse.data.key,
            this.propalService.propalResponse.display.booking,
            this.route.snapshot.params.idAlternative
        );

        const onOfferSelectedNotificationArray: IOnOfferSelectedNotificationSetup[] = this.sessionPostOnUpdateBooking && this.sessionPostOnUpdateBooking.onOfferSelectedNotificationArray ?
            this.sessionPostOnUpdateBooking.onOfferSelectedNotificationArray : null;

        if (this.savedOfferLoaded) {
            this.saveOfferRequest(saveOfferId, this.savedOfferLoaded as ResponseForConvertOfferAfx2jsonType, onOfferSelectedNotificationArray);
            return;
        }

        this.propalService.setPropalDisplay(this.propalResponse.data.selectedQuote.segment, this.propalResponse.data.selectedQuoteJourneys);

        this.quotedAvailabilityService.getQuotedAvailabilityStream(
            this.propalResponse.display.booking,
            this.propalResponse.data.selectedQuoteJourneys,
            this.serviceSelection
        )
            .subscribe((gqaResult: ResponseForConvertOfferAfx2jsonType) => {
                this.saveOfferRequest(saveOfferId, gqaResult, onOfferSelectedNotificationArray);
            });
    }


    private saveOfferRequest(saveOfferId: string, result, onOfferSelectedNotificationArray): void {
        this.onOfferSelectedExternalLink = null;

        const onOfferSelectedExternalLink: IBookingExternalLink = this.propalResponse.searchRQ?.body?.onOfferSelectedExternalLink;
        const saveOfferRequest: IAirSaveOfferRequest = this.offerService.buildPostRequest(
            saveOfferId,
            result,
            onOfferSelectedNotificationArray);

        // to move to wait for saveOffer response
        this.loader.message = this.wording.saveOfferWaiting;

        this.offerService.saveOffer(saveOfferRequest, wenji.ui.target)
            .subscribe({
                    next: (response: any): void => {
                        if (response.warningMessage && response.warningMessage.length > 0) {
                            this.savingOffer.warning.active = true;
                            this.savingOffer.warning.message = response.warningMessage;
                        }
                        this.saveOfferId = saveOfferId;
                        this.savingOffer.error.active = false;
                        this.loader.active = false;
                        this.savingOffer.done = true;
                        this.resetServiceSelection();
                        if (onOfferSelectedExternalLink) {
                            onOfferSelectedExternalLink.quoteKey = saveOfferId;
                            this.onOfferSelectedExternalLink = onOfferSelectedExternalLink;
                        }
                    },
                    error: (error: ResourceError): void => {
                        this.errorTracingService.captureException(error);
                        this.loader.active = false;
                        this.savingOffer.done = true;
                        this.savingOffer.error.active = true;
                        this.savingOffer.error.message = error.message;
                        this.onOfferSelectedExternalLink = null;
                    }
                }
            );
    }

    /**
     * text for quote modal button
     **/
    public getQuotesButton(): string {
        let output: string = '';

        output += this.wording.autresPropositions;

        return output;
    }

    /**
     * count if there are "autres vols"
     * @bookingKey : only from Quotes
     */

    public isJourney(bookingKey?: string): boolean {
        let output: boolean = false;

        if (!this.propalResponse.display?.firstSegments?.length &&
            !this.quoteResponse.data?.booking) {
            return false;
        }

        if (!bookingKey || !this.quoteResponse.data.booking[bookingKey]) {
            for (const segment of this.propalResponse.display.firstSegments) {
                if (segment.journey.length > 1) {
                    output = true;
                }
            }
        } else {
            for (const segmentKey of Object.keys(this.quoteResponse.data.booking[bookingKey].segment)) {
                if (this.quoteResponse.data.booking[bookingKey].segment[segmentKey].journey.length > 1) {
                    output = true;
                }
            }
        }


        return output;
    }


    public showQuoteSectorsModal(bookingKey: any): void {
        this.getQuote(bookingKey);
        this.setQuoteSectorsModal(bookingKey);
        this.sectorsModal.show();
    }

    public returnToWTB(): void {
        sessionStorage.removeItem("IQBA_ExternalApplicationData");
        sessionStorage.removeItem("$post");
        sessionStorage.removeItem("autoLaunchPNRSearch");
        window.location.href = `${this.navigationOrigin.location}wui_watabi/${this.navigationOrigin.bookingIdItem}/${this.navigationOrigin.bookingIdVersion}`;
    }

    public returnToSasha(syscode?: string): void {
        window.location.href = `${window.location.href.replace(/locobook\/search.*/, 'sasha/booking')}/${syscode ?? this.sessionPostOnUpdateBooking.booking.syscode}`;
    }

    public returnToWatabi(code?: string): void {
        window.location.href = this.applicationData.location + (code ? '&codePnr=' + code : '');
    }

    private cleanSessionStorageFromWatabi(): void {
        sessionStorage.removeItem("autoLaunchPNRSearch");
        sessionStorage.removeItem("IQBA_ExternalApplicationData");
    }

    /**
     * action for button "Retour" on sectorModal when opened from Quotes modal
     */
    public backToQuotes(origin: string): void {
        const context: string = `${origin}.hide`;
        _invoke(this, context);
        this.quotesModal.showModal = true;
    }

    /*
    * Define content to display in sectors modal form QuoteList
    */
    public setQuoteSectorsModal(bookingKey: any): void {

        this.initQuotesSectorsDisplay(bookingKey);

        this.quotesModal.hide();
    }

    /*
    * displayed segments and sectors for Quotes
    **/
    public initQuotesSectorsDisplay(bookingKey: string): void {
        //Initialize containers if needed
        if (!this.quoteResponse.display.selectedSegments) {
            this.quoteResponse.display.selectedSegments = {};
        }

        if (!this.quoteResponse.display.selectedJourneys) {
            this.quoteResponse.display.selectedJourneys = {};
        }

        if (!this.quoteResponse.display.selectedSegments[bookingKey]) {
            const segList: string[] = Object.keys(this.quoteResponse.data.booking[bookingKey].segment);
            this.quoteResponse.display.selectedSegments[bookingKey] = segList;
        }

        if (!this.quoteResponse.display.selectedJourneys[bookingKey]) {

            const jourList: any[] = [];
            for (const segmentKey of this.quoteResponse.display.selectedSegments[bookingKey]) {
                jourList.push(this.quoteResponse.data.booking[bookingKey].segment[segmentKey].journey[0]);
            }
            this.quoteResponse.display.selectedJourneys[bookingKey] = jourList;
        }
    }

    public setJourneysModal(segments: any, journeys: any, bookingKey: any, back: boolean = false): void {

        let segmentsCopy: any[] = [];
        if (_isPlainObject(segments)) {
            for (const key of Object.keys(segments)) {
                segmentsCopy.push(segments[key]);
            }
        } else {
            segmentsCopy = segments;
        }
        this.journeysModalContent.segments = segmentsCopy;

        this.journeysModalContent.journeyList = journeys;
        this.journeysModalContent.booking = bookingKey;
        this.journeysModalContent.back = back;
        //
        if (back) {
            this.journeysModalContent.fromQuotes = true;
            this.initQuotesSectorsDisplay(bookingKey);

            this.journeysModal.show();
            this.quotesModal.hide();

        } else {

            this.journeysModalContent.fromQuotes = false;
        }

    }

    /*
    * Define content to display in journeys modal form QuoteList
    */
    public setQuoteJourneysModal(bookingKey: any): void {
        this.initQuotesSectorsDisplay(bookingKey);


        //let backModal = "test"
        this.setJourneysModal(
            this.quoteResponse.data.booking[bookingKey].segment,
            this.quoteResponse.display.selectedJourneys[bookingKey],
            bookingKey,
            true
        );

    }

    public reset(): void {
        this.quoteService.response.appliedFilter = {};
    }

    public countNewTraveller(quantity: any) {
        this.travellerFormList = [];

        const travellersList = [];
        for (let i = 0; i < quantity?.adult; i++) {
            const traveller: any = {
                key: "T_" + (i + 1),
                type: "Adult"
            };
            travellersList.push(traveller);
        }
        for (let i = 0; i < quantity?.child; i++) {
            const traveller: any = {
                key: "T_" + (i + 1 + quantity?.adult),
                type: "Child"
            };
            travellersList.push(traveller);
        }
        for (let i = 0; i < quantity?.infant; i++) {
            const traveller: any = {
                key: "T_" + (i + 1 + quantity?.adult + quantity?.child),
                type: "Infant"
            };
            travellersList.push(traveller);
        }
        this.travellerFormList = travellersList;


    }

    public setTraveller(traveller: any) {
        // if (this.propalResponse.data) {
        if (!this.propalResponse.traveller) {
            this.propalResponse.traveller = {};
        }

        //usefull when several travellers
        _set(traveller, 'xId', traveller.id);

        this.propalResponse.traveller[traveller.id] = traveller;
        this.travellerService.traveller[traveller.id] = traveller;

        if (Object.keys(this.propalResponse.traveller).length === this.travellerFormList.length) {
            this.validTraveller(this.propalResponse.traveller);
        }

        if (this.sessionPostOnUpdateBooking) {
            this.validTraveller(this.propalResponse.traveller);
        }
    }

    public validTraveller(_travellers: []): boolean {

        const travellerEditable: boolean = this.isPerm('searchPage.travellerTile.edit');
        let valid: boolean = true;
        const birthDate = {};

        _set(birthDate, 'Adult', 0);
        _set(birthDate, 'Child', 0);
        _set(birthDate, 'Infant', 0);

        let nbAdult: number = 0;
        const deleteApis: string[] = [];
        if (!_travellers || Object.keys(_travellers).length === 0) {
            valid = false;
        } else {

            _forEach(_travellers, (traveller: any, travellerKey: string) => {
                //base data needed
                if (!traveller.firstName ||
                    !traveller.lastName ||
                    !traveller.type) {
                    valid = false;
                }

                if (this.isNonEmpty(traveller.passport) && this.invalidPassportInfo(traveller.passport)) {
                    valid = false;
                }

                if (this.isNonEmpty(traveller.identityCard) && this.invalidIdentityCardInfo(traveller.identityCard)) {
                    valid = false;
                }
                if (this.propalResponse.data?.selectedQuote?.actionArray?.length) {
                    const apisServiceQuality: ActionInBookingType = this.actionQualityHelperService.extractActionByQualificationForQuotedAvailabilityTrip(
                        _cloneDeep(this.propalResponse.data?.selectedQuote?.actionArray),
                        EServiceQualityEnum.APIS
                    );
                    if (apisServiceQuality && !apisServiceQuality.xMatch && apisServiceQuality.textLineArray?.length) {
                        if (apisServiceQuality.textLineArray[0] === "APIS") {
                            if (!traveller.identityCard && !traveller.passport) {
                                valid = false;
                            }
                            if (traveller.passport && !traveller.identityCard && this.invalidPassportInfo(traveller.passport)) {
                                valid = false;
                            }
                            if (!traveller.passport && traveller.identityCard && this.invalidIdentityCardInfo(traveller.identityCard)) {
                                valid = false;
                            }

                        }
                        // both cases APIS && SFPD
                        if (!traveller.birthDate) {
                            valid = false;
                        }
                    }

                }

                //default title
                if (!traveller.title) {
                    _set(traveller, 'title', 'Mr');
                }

                //birthDate needed for child && infant
                if (traveller.type !== 'Adult' && !traveller.birthDate) {
                    valid = false;
                }

                if (traveller.birthDate && moment().isBefore(traveller.birthDate)) {
                    valid = false;
                }

                //count Adult
                if (traveller.type === 'Adult') {
                    nbAdult++;
                }

            });
        }

        // at least 1 adult
        if (nbAdult < 1) {
            valid = false;
        }


        this.canCreatePNR = valid;
        return this.canCreatePNR;
    }

    /****
     * showSearchAbstract
     * conditions to show/hide search abstract
     **/
    public showSearchAbstract(): boolean {
        let output: boolean;

        //datas from the outside
        if (this.isPost &&
            ((Object.keys(this.propalResponse.traveller).length > 0 || this.traveller.length > 0) && !this.idSearch)) {
            output = true;
        }

        //datas from form
        if (this.searchSent) {
            output = true;
        }

        return output;
    }

    public showTravellerForm(_key: string): void {
        if (!_find(this.bcItems, (o) => {
            return o.action.name === "travellerPage";
        })) {

            this.breadcrumbIqba.addPage(this.breadcrumbIqba.provisionalItems.travellerPage);
        }
        this.breadcrumbIqba.setActive(1);
        this.breadcrumbIqba.setClickable(0, true);
        this.breadcrumbIqba.setClickable(1, false);
    }

    /**
     * action Dispatcher for breadCrumb
     *
     */
    public async bcNavigate(_action: any) {

        switch (_action.name) {
            case 'searchPage':
                this.breadcrumbIqba.setActive(0);
                this.breadcrumbIqba.setClickable(0, false);
                this.breadcrumbIqba.setClickable(1, true);
                this.resetPnrCreationError();
                break;
            case 'travellerPage':
                this.showTravellerForm('T_1');
                this.resetPnrCreationError();
                this.showQuotes = false;
                break;
            case 'pnrPage':

                if (this.breadcrumbIqba.getPnrPageParameters()) {
                    const pnrPageParameters: IPnrPageParameters = this.breadcrumbIqba.getPnrPageParameters();
                    await this.router.navigate([
                        IqbaPathSegment.Locobook,
                        IqbaPathSegment.Hosts,
                        pnrPageParameters.host,
                        IqbaPathSegment.Bookings,
                        pnrPageParameters.booking]
                    );
                }
                this.resetPnrCreationError();
                break;
            case 'itineraryPage':
                this.breadcrumbIqba.setActive(0);
                this.breadcrumbIqba.setClickable(0, false);
                this.breadcrumbIqba.setClickable(1, true);
                this.resetPnrCreationError();
                break;
            default:
                break;
        }
    }

    public bcIsActive(_tileName): boolean {
        return this.breadcrumbIqba.isTileInActive(_tileName);
    }

    public bcNbPages(): number {
        return this.breadcrumbIqba.nbPages();
    }

    public isPerm(_perm, _root?): boolean {
        return this.rights.isPerm(_perm, _root);
    }

    public showOtherPlain(bookingKey): void {
        this.getQuote(bookingKey);
        this.setQuoteJourneysModal(bookingKey);
        this.journeysModal.show();
    }

    public openAllSegments(quoteId: string): void {
        this.getQuote(quoteId);

        this.bookingComponent.showFlightDetails = [];
        const data: IAllSegmentsDialogData = {
            quoteId,
            segmentList: this.propalResponse.data.booking[quoteId].segment,
            selectedSegment: this.propalResponse.display.selectedJourneys,
        };
        const dialog = this.dialog.open(AllSegmentDialogComponent, {
            data,
        });

        dialog.afterClosed().subscribe((selectedSegmentInfo: ISegmentSelect) => {
            this.selectOtherFlight({
                selectedJourneys: selectedSegmentInfo.selectedSegment, quoteId: selectedSegmentInfo.quoteId
            });
        });
    }

    public selectOtherFlight(selectedSegmentInfo?: IOutSelectQuote): void {
        if (selectedSegmentInfo) {
            this.cacheQuotedAvailabilityService.clearCache();
            this.chooseJourney(selectedSegmentInfo.selectedJourneys, selectedSegmentInfo.quoteId);
            this.selectQuote({
                quoteId: selectedSegmentInfo.quoteId,
                selectedJourneys: selectedSegmentInfo.selectedJourneys
            });
        }
    }

    public toggleQuotes(): void {

        this.selectQuote({
            quoteId: this.propalResponse?.display?.booking,
            selectedJourneys: this.propalResponse?.display?.selectedJourneys
        });

    }

    /**
     *
     * get info from $post or Form
     */
    public getInfos(_searchRQ: any, noInitJourneys?: boolean): void {
        this.originalRequest = {body: _searchRQ};
        _searchRQ.host = Array.isArray(_searchRQ.host) ?
            _searchRQ.host :
            [_searchRQ.host];
        this.post = _searchRQ;

        this.propalResponse.searchRQ = _searchRQ;
        if (!noInitJourneys) {
            this.propalResponse.display.selectedJourneys = null;
        }
        if (!this.propalResponse.traveller || Object.keys(this.propalResponse.traveller).length === 0) {
            this.propalResponse.traveller = this.traveller;
        }

        this.initQuoteResponse();
        this.segment = this.segmentService.getSegment(_searchRQ);
        this.traveller = this.travellerService.getTraveller(_searchRQ);
        this.carrier = this.carrierService.getCarrier(_searchRQ);
        this.price = this.priceService.getPrice(_searchRQ);
        this.quantity = _searchRQ.quantity;
        this.keyword = _searchRQ.keyword;
        this.host = _searchRQ.host;
        this.fullServiceCarriersOnly = _searchRQ.fullServiceCarriersOnly;
        this.flexibility = _get(_searchRQ, 'flexibility');
        this.locator = _searchRQ.locator;
        this.loaded = true;
        this.workflowCode = _searchRQ.workflow?.code;
    }

    public submitSearch(airSearchRequest: IAirSearchRequest): void {
        this.searchErrorMessage = null;
        this.setRoutHostMessage(null);
        this.quoteService.resetResult();
        this.cacheQuotedAvailabilityService.clearCache();
        this.propalService.propalResponse.data = null;
        this.propalService.propalResponse.message = null;
        this.propalService.propalResponse.searchForm = airSearchRequest;
        this.airSearchRequest = airSearchRequest;
        this.searchSent = true;
        this.showFlightForm = false;
        this.showQuotes = DEFAULT_SHOW_QUOTES;
        this.getInfos(airSearchRequest);
        this.resetSaveOffer();
        this.resetSilentBooking();
        this.resetServiceSelection();
        this.getHostAvailableSubscription = this.dictionaryRoutesHostsService.getHostsAvailable(airSearchRequest)
            .subscribe({
                next: ((host: string[]) => {
                    if (host?.length) {
                        const dataToSearch = {
                            ...airSearchRequest,
                            host
                        };
                        this.handleSearch(dataToSearch);
                    } else {
                        this.setRoutHostMessage(this.wording.incorrectHost);
                    }
                }),
                error: (error: ResourceError): void => {
                    // #30996 if not list host available and error make search with actual host
                    this.handleSearch(airSearchRequest);
                    // uncomment next line to see error message in interface
                    // this.onDictionaryRoutesHostsError.emit(error.message);
                }
        });

    }

    private handleSearch(airSearchRequest: IAirSearchRequest): void {
        if (this.getPropalDataSubscription) {
            this.getPropalDataSubscription.unsubscribe();
        }
        this.getPropalDataSubscription = this.propalService.getPropalData(airSearchRequest, false)
            .subscribe({
                next: (quote: IGetAirTripQuotes): void => {
                    this.propalService.storeResult(quote);
                },
                error: (err: ResourceError): void => {
                    this.searchErrorMessage = err.message;
                    this.propalService.propalResponse.message = err.message;
                }
        });
    }

    public offerCanBeBooked(): boolean {
        return !this.workflowCode || (this.workflowCode && (this.workflowCode === "CompleteBookingProcess" || this.workflowCode === "LoadAndValidateSavedOffer"));
    }

    public navigateToAncillaryServices(): void {
        //trick to ensure navigation in every situation
        // const path: string = window.location.pathname.split('wui/')[1];
        // if(!path.includes(IqbaPathSegment.AncillaryServices)){
        //     this.location.replaceState(`${path}/${IqbaPathSegment.AncillaryServices}`);
        // }
        this.isAlternativeFaresVisible = false;
        this.isShowAncillaryServices = true;
        this.isShowAncillaryServicesSelection = false;
        this.ancillaryServicesNotification.active = false;
        this.prepareDataForAncillaryServices();
    }

    private prepareDataForAncillaryServices(): void {
        this.segmentsForServices = this.pnrService.getSegment(this.propalResponse.data.selectedQuote);
        this.actualFareFamily = Boolean(this.propalResponse.data?.selectedQuote?.fareFamily) ?
            this.propalResponse.data?.selectedQuote?.fareFamily :
            null;

    }

    private getNavigationOrigin(): void {
        this.navigationOrigin = JSON.parse(sessionStorage.getItem('IQBA_ExternalApplicationData'));
    }

    private sendGetQuotedAvailabilityRequest(bookingKey: string, selectedJourneysTmp?: string[], alternativeOfferXId?: string):
        Observable<{ request: IAirGetQuotedAvailabilityRequest, response: IAirQuotedAvailabilityResponse }> {
        const selectedJourneys = selectedJourneysTmp || this.propalResponse.display.selectedJourneys;
        const userInfo = JSON.parse(sessionStorage.getItem("userInformations")); //TODO get user with a better way
        const userId: number = userInfo.sam_contact.id;
        const companyId: number = userInfo.sam_company;
        const locator: string = this.propalService.propalResponse.searchRQ.body.locator;
        const isLowCost: boolean = this.isLowCost();
        let vendor = null;
        let externalBooking: IAirExternalBooking = null;

        if (isLowCost) {
            vendor = this.propalResponse.data.booking[this.propalResponse.display.booking].vendor;
            externalBooking = this.sessionPostOnUpdateBooking && this.sessionPostOnUpdateBooking.externalBooking ?
                this.sessionPostOnUpdateBooking.externalBooking :
                null;
        }

        return this.cacheSamResourceService.getAgentAndCompany(userId, companyId).pipe(
            map(([samAgent, samCompany]: [ISamAgent, ISamCompany]) => {
                return this.quotedAvailabilityService.buildRequest(
                    bookingKey,
                    selectedJourneys,
                    samAgent,
                    samCompany,
                    locator,
                    isLowCost,
                    externalBooking,
                    vendor
                );
            }),
            flatMap((request: IAirGetQuotedAvailabilityRequest)
                : Observable<{ request: IAirGetQuotedAvailabilityRequest, response: IAirQuotedAvailabilityResponse }> => {
                return this.quotedAvailabilityService.sendRequest(request, bookingKey, alternativeOfferXId);
            }),
        );
    }

    private isLowCost(): boolean {
        return this.lowCostCompanyService.hasLcc(
            this.propalResponse.data.booking[this.propalResponse.display.booking],
            this.propalResponse.display.selectedJourneys);
    }

    private isNonEmpty(identityDocument: IPassport): boolean {
        return identityDocument
            && (!identityDocument.number
                && (!identityDocument.validity || !identityDocument.validity.end)
                && !identityDocument.country);
    }

    private invalidPassportInfo(identityInfo): boolean {
        const info = _cloneDeep(identityInfo);

        if (info.issuance?.country && !info.issuance?.passCountry) {
            info.issuance.passCountry = info.issuance.country;
        }
        if (info.validity?.end && !info.validity?.passEnd) {
            info.validity.passEnd = info.validity.end;
        }
        if (info.number && !info.passNumber) {
            info.passNumber = info.number;
        }

        return (
            !info.issuance ||
            !info.issuance.passCountry ||
            !info.validity ||
            !info.validity.passEnd ||
            !info.passNumber
        );
    }

    private invalidIdentityCardInfo(identityInfo): boolean {

        const info = _cloneDeep(identityInfo);

        if (info.issuance?.country && !info.issuance?.cardCountry) {
            info.issuance.cardCountry = info.issuance?.country;
        }
        if (info.validity?.end && !info.validity?.cardEnd) {
            info.validity.cardEnd = info.validity?.end;
        }
        if (info.number && !info.cardNumber) {
            info.cardNumber = info.number;
        }

        return (
            !info.issuance ||
            !info.issuance.cardCountry ||
            !info.validity ||
            !info.validity.cardEnd ||
            !info.cardNumber
        );
    }


    private addRemoveTravellers(generatedTravellers): void {
        if (!this.propalResponse.traveller || Object.keys(this.propalResponse.traveller).length === 0) {
            _set(this, 'propalResponse.traveller', generatedTravellers);
            return;
        }

        const currentKeys = new Set(Object.keys(this.propalResponse.traveller));
        const generatedKeys = new Set(Object.keys(generatedTravellers));

        Array.from(currentKeys)
            .filter((key) => !generatedKeys.has(key))
            .forEach((key) => {
                // Creates a new instance to facilitate change detection
                this.propalResponse.traveller = _omit(this.propalResponse.traveller, key);
            });

        Array.from(generatedKeys)
            .filter((key) => !currentKeys.has(key))
            .forEach((key) => {
                // Creates a new instance to facilitate change detection

                this.propalResponse.traveller = {
                    [key]: generatedTravellers[key],
                    ...this.propalResponse.traveller
                };
            });
    }

    private initQuoteHasLcc(): void {
        this.quoteHasLcc = this.lowCostCompanyService.hasLcc(
            this.propalResponse.data.booking[this.propalResponse.display.booking],
            this.propalResponse.display.selectedJourneys
        );
    }

    private initQuoteResponse(): void {
        this.quoteResponse.display.selectedJourneys = [];
    }

    private resetPnrCreationError(): void {
        this.pnrCreationError = {
            active: false,
            message: null,
            technicalMessage: null,
        };
    }

    public resetSaveOffer(): void {
        this.savingOffer.done = false;
        this.savingOffer.show = false;
        this.savingOffer.error = {
            active: false,
            message: null
        };
    }

    public resetSilentBooking(): void {
        this.silentBook.done = false;
        this.silentBook.show = false;
        this.silentBook.error = {
            active: false,
            message: null
        };
    }

    public showQuoteWithServiceSelection(validateOutput: IValidateOutput): void {
        this.serviceSelection = null;
        this.seatMapResponse = null;

        this.ancillaryServicesNotification.active = false;
        this.isShowAncillaryServicesSelection = true;
        this.isShowAncillaryServices = false;
        this.cacheQuotedAvailabilityService.storeCreateBookingWithServiceSelectionRequest(validateOutput.nextRequest);
        this.serviceSelection = _cloneDeep(validateOutput.validatedOffer);
        this.seatMapResponse = validateOutput.retrievedSeatMap ? _cloneDeep(validateOutput.retrievedSeatMap) : null;
        // @ts-ignore
        this.propalService.storeSelectedQuote(this.airQuoteMappingService.mapGqaNewToOld(
            validateOutput.validatedOffer,
            undefined,
            EUsedXReason.TransportationPlusPayment));

        this.changeDetectorRef.detectChanges();
    }

    public showAncillaryServicesError(message?: string): void {
        if (Boolean(message)) {
            this.ancillaryServicesNotification.message = message;
            this.ancillaryServicesNotification.type = NotificationType.Error;
        } else {
            this.ancillaryServicesNotification.message = Yii.t('wui-shared-js', 'Aucun service disponible sur cette offre.');
            this.ancillaryServicesNotification.type = NotificationType.Warning;

        }
        this.ancillaryServicesNotification.active = true;
        this.isShowAncillaryServicesSelection = false;
        this.isShowAncillaryServices = false;
        this.serviceSelection = null;
        this.seatMapResponse = null;
    }

    public resetServiceSelection(): void {
        this.serviceSelection = null;
        this.seatMapResponse = null;
        this.ancillaryServicesNotification.active = false;
        this.isShowAncillaryServicesSelection = false;
        this.isShowAncillaryServices = false;
        //this.updatedBookingFlightPrices = null;
        this.cacheQuotedAvailabilityService.clearServiceCache();
        this.changeDetectorRef.detectChanges();
    }

    public showSaveButton(): boolean {
        const isLowcost: boolean = this.lowCostCompanyService.hasLcc(
                this.propalResponse.data.booking[this.propalResponse.display.booking],
                this.propalResponse.display.selectedJourneys) &&
            this.offerCanBeBooked();
        if (this.bookingSaveOffer) {
            if (isLowcost && wenji.locobook.vcc && this.vccPermission) {
                return true;
            } else if (!isLowcost) {
                return true;
            }
        }

        return false;
    }

    public storeNotes(): void {
        this.notes = this.notepadComponent.extractValues();
    }

    public redirectToExternalLink(externalLink: IBookingExternalLink): void {
        const host: string = this.propalResponse?.data?.selectedQuote?.host;
        const searchKey: string = this.propalResponse?.data?.key;
        const quoteKey: string = this.propalResponse?.display?.booking;

        const link: string = externalLink.addOfferArgsToURL ?
            `${externalLink.link}?host=${host}&searchKey=${searchKey}&quoteKey=${quoteKey}&offerKey=${externalLink.quoteKey}` :
            externalLink.link;

        this.externalRedirectionService.redirectTo(link, externalLink.openInNewWindow);
    }

    private getAlternativeOnLanding(parameters: Params): void {
        this.propalResponse.display = {
            ...this.propalResponse.display,
            idSearch: parameters.idSearch,
            idQuote: parameters.idQuote
        };
        this.searchSent = true;
        this.showFlightForm = false;
        this.showQuotes = false;
        this.loader.active = true;
        this.loader.message = this.wording.gqaLoading;
        this.propalService.getPropalWithKeys(parameters.idSearch, parameters.idQuote).pipe(
            tap((quote: any): void => {
                this.propalService.storeResult(quote, false);
                this.propalService.storeQuote(quote.booking);
                this.propalService.selectQuote(quote.booking, false);
            }),
            mergeMap((quote: any): Observable<any> => {
                return this.getSearchRequest();
            }),
            mergeMap((quote: any)
                : Observable<{ request: IAirGetQuotedAvailabilityRequest, response: IAirQuotedAvailabilityResponse }> => {
                this.loader.message = Yii.t('wui-iqba-js', 'Vérification de la cotation auprès du GDS');
                return this.sendGetQuotedAvailabilityRequest(parameters.idQuote, null, parameters.idAlternative)
                    .pipe(
                        catchError((error: Error): Observable<{ response: IAirQuotedAvailabilityResponse, request: IAirGetQuotedAvailabilityRequest }> => {
                            console.error(error);
                            this.propalResponse.message = error.message;
                            this.loader.active = false;
                            this.priceStillValid = false;
                            throw new RuntimeError(error.message, error);
                        })
                    );
            }),
            tap(({response}: { request: IAirGetQuotedAvailabilityRequest, response: IAirQuotedAvailabilityResponse }): void => {
                this.propalService.storeSelectedQuote(response);
                this.propalResponse.data.booking[this.propalResponse.display.booking] = response;
                const booking: any = this.propalResponse.data.booking[this.propalResponse.display.booking];
                const sqaQuotePrice: number = this.pnrService.getCostPrice(booking);
                const quoteAvailabilityPrice: number = this.pnrService.getCostPrice(response);
                this.showPNRForm = true;
                this.loader.active = false;
                this.priceStillValid = true;
                // this.selectedFareFamilyXId = Object.keys(response.fareFamily)[0];
                this.propalResponse.transactionId = response.transactionId;
                this.initQuoteHasLcc();

                this.propalResponse.warningMessage =
                    quoteAvailabilityPrice !== sqaQuotePrice ?
                        this.quoteHasLcc ?
                            this.wording.priceChangesForLcc : this.wording.priceChanges
                        : null;
            })
        ).subscribe({
            next: (): void => {
                this.loader.active = false;
                this.isShowAncillaryServices = window.location.pathname.includes(IqbaPathSegment.AncillaryServices);
            }
        });
    }

    private computeSearchFormUse(permission: IPermission): void {
        this.searchFormUse = permission && permission.searchForm && Object.keys(permission.searchForm).includes("use") ? permission.searchForm.use : true;
    }

    private computeBookingSaveOffer(permission: IPermission): void {
        if (!this.bookingSaveOffer) {
            this.bookingSaveOffer = permission && permission.booking && Object.keys(permission.booking).includes("saveOffer") ? permission.booking.saveOffer : false;
        }
    }

    public isOfferSelection(): boolean {
        return this.workflowCode && this.workflowCode === 'OfferSelection' && this.bookingSaveOffer;
    }

    private submitNamedFormSubscription(): void {

        this.subscription2 = this.formBuilderService
            .submitNamedForm
            .subscribe(
                (_event: any): void => {
                    if (_event.formName === "travellerForm") {
                        //only existing pax to be updated
                        const keys = Object.keys(this.propalResponse.traveller);
                        const modifTraveller = _filter(_event.data.traveller, (traveller: any) => {
                            return _includes(keys, traveller.id);
                        });
                        _forEach(modifTraveller, (traveller: any) => {
                            this.setTraveller(traveller);
                        });
                    }
                });
    }

    private infoSubscription(): void {
        this.subscription = this.formBuilderService
            .info
            .subscribe(
                (_data: any): void => {
                    if (Object.keys(_data).length && _data.travellerFormData) {
                        this.travellerFormData = _data.travellerFormData.traveller;
                    }
                    if (Object.keys(_data).length && _data.quantity) {
                        this.countNewTraveller(_data.quantity);

                        const generatedTravellers = _cloneDeep(
                            this.travellerService.getTravellerFromQuantity(_data.quantity)
                        );

                        this.addRemoveTravellers(generatedTravellers);

                        this.validTraveller(this.propalResponse.traveller);

                        this.toggleFlexibilityMenu = false;
                        this.flexibilityLabel = Yii.t('wui-iqba-js', 'Flexibilité des départs');
                    }
                });
    }

    private getPropalData($post: IAirSearchRequest): void {
        $post = {
            ...$post,
            flexibility: $post.segment?.length === 2 && $post.flexibility ? $post.flexibility : null,
            wayType: EWayType.Multiple
        };
        this.propalService.getPropalData($post)
            .pipe(
                flatMap((data: IGetAirTripQuotes) => {
                    this.propalService.storeResult(data);
                    this.airSearchResourceService.onSearchIdTripChange.emit(data.key);
                    this.searchSent = true;
                    this.propalResponse.traveller = this.traveller;

                    _forEach(this.propalResponse.traveller,
                        (travellerData: any, travellerId: string) => {
                            _set(travellerData, 'id', travellerId);
                            _set(travellerData, 'xId', travellerId);
                        });

                    this.validTraveller(this.propalResponse.traveller);

                    return this.getSearchRequest();
                })
            )
            .subscribe({
                next: (): void => {
                    this.initQuoteHasLcc();
                },
                error: (error: ResourceError): void => {
                    this.errorTracingService.captureException(error);
                    this.propalResponse.message = error.message;
                    this.searchErrorMessage = error.message;
                    this.airSearchResourceService.onSearchIdTripChange.emit(null);
                }
            });
    }

    private searchOnLandingWithExistingSearchId(parameters: Params, relocateRoute: boolean = true): void {
        this.propalResponse.display = {
            ...this.propalResponse.display,
            idSearch: parameters.idSearch,
            idQuote: parameters.idQuote
        };
        this.searchSent = true;
        this.showFlightForm = false;
        this.getPropalWithKeys(parameters, relocateRoute);
    }

    private getPropalWithKeys(parameters: Params, relocateRoute: boolean = true): void {
        this.propalService.getPropalWithKeys(parameters.idSearch, parameters.idQuote)
            .pipe(
                flatMap(
                    (quote: IQuote) => {
                        this.propalService.storeResult(quote, relocateRoute);
                        this.propalService.propalResponse.traveller = _cloneDeep(
                            this.propalService
                                .propalResponse
                                .data
                                .booking[this.propalService.propalResponse.display.booking]
                                .traveller
                        );
                        _forEach(this.propalService.propalResponse.traveller,
                            (travellerData: any, travellerId: string) => {
                                _set(travellerData, 'id', travellerId);
                                _set(travellerData, 'xId', travellerId);
                            });
                        this.validTraveller(this.propalService.propalResponse.traveller);
                        return this.getSearchRequest();
                    })
            )
            .subscribe((): void => {
                    this.initQuoteHasLcc();
                    this.isShowAncillaryServices = window.location.pathname.includes(IqbaPathSegment.AncillaryServices);
                },
                (error: ResourceError): void => {
                    this.errorTracingService.captureException(error);
                    this.propalResponse.message = error.message;
                }
            );
    }

    private initRights(): void {

        this.permissionResource.hasPermission(NOTEPAD_EDITOR_PERMISSION).subscribe({
            next: (isPermitted: boolean): void => {
                this.isNotepadPermission = isPermitted;
            }
        });

        this.permissionResource.getPermissions().subscribe({
            next: (permissions: Set<string>): void => {
                this.vccPermission = permissions.has("iqba.booking.virtual.card.create");
                this.showNDCBook = permissions.has('iqba.booking.ndc.create');
                this.skipVccConfirmationPermission = permissions.has(" iqba.booking.virtual.card.confirmation.skip");
                this.skipVccConfirmationPermission = permissions.has(" iqba.booking.virtual.card.confirmation.skip");
                this.showLowcostBook = this.vccPermission && !!Number(wenji.locobook.vcc);
                if (!this.bookingSaveOffer) {
                    this.bookingSaveOffer = permissions.has("iqba.booking.offer.save");
                }
            }
        });

        this.rightsSubscription = this.rights.getRights()
            .subscribe((permissions: any): void => {
                this.searchFormUse = permissions.iqba.searchPage.searchTile.view;
                if (this.sessionPostOnUpdateBooking) {
                    this.computeSearchFormUse(this.sessionPostOnUpdateBooking.permission);
                    this.computeBookingSaveOffer(this.sessionPostOnUpdateBooking.permission);
                }
                if (this.searchFormUse && !this.sessionPostOnUpdateBooking) {
                    this.travellerForm = true;
                }
                //HERE TO OVERWRITE RIGTHS
                if (this.sessionPostOnUpdateBooking) {
                    const rightOverwrite = _get(
                        this.sessionPostOnUpdateBooking,
                        'permission.booking.create'
                    );

                    if (!_isUndefined(rightOverwrite) && this.isPerm('booking.create')) {
                        this.rights.setPermission('iqba.booking.create', rightOverwrite);
                    }
                }

                this.rightsGotten = true;
            });
    }

    private initBreadcrumb(): void {
        this.viewSubscription = this.viewService.getView()
            .subscribe((view: any): void => {
                if (this.bcItems.length === 0) {
                    let bcData = this.viewService.getPagesOnBreadcrumb(
                        view.pages.iqba.step, this.breadcrumbIqba.items,
                        this.breadcrumbIqba.provisionalItems);

                    this.breadcrumbIqba.setItems(bcData.items);
                    this.breadcrumbIqba.setProvisionalItems(bcData.provisionalItems);
                }
            });
        if (this.bcItems.length > 1 && this.breadcrumbIqba.isActive(1)) {
            this.showTravellerForm('T_1');
        }
    }

    private searchOnLandingWithSessionStorageSearchArguments(autoLaunchPNRSearchOnLanding: boolean): void {
        const hasOfferKey = this.sessionPostOnUpdateBooking?.offer?.offerKey;
        this.searchSent = autoLaunchPNRSearchOnLanding;
        //Base informations - critères
        this.showFlightForm = !(autoLaunchPNRSearchOnLanding || hasOfferKey);
        this.getInfos(this.sessionPostOnUpdateBooking);

        //overright permissions
        if (this.sessionPostOnUpdateBooking.permission) {
            this.rights.setPermissions("iqba", this.sessionPostOnUpdateBooking.permission);
        }

        const WORKFLOW_CODES = ['OfferSelection', 'CompleteBookingProcess', 'SilentBookingUsingOffer', 'SilentBestOfferSelection', 'LoadAndValidateSavedOffer'];

        if (this.workflowCode && WORKFLOW_CODES.includes(this.workflowCode)) {
            if (hasOfferKey && this.workflowCode === 'SilentBookingUsingOffer') {
                this.silentBooking(this.sessionPostOnUpdateBooking);
            } else if (this.workflowCode === 'SilentBestOfferSelection') {
                this.silentBestOfferSelection(this.sessionPostOnUpdateBooking);
            } else if (this.workflowCode === 'LoadAndValidateSavedOffer') {
                this.getSavedOffer();
            } else {
                this.getPropalData(this.sessionPostOnUpdateBooking);
            }
        } else if (autoLaunchPNRSearchOnLanding) {
            const copy = _cloneDeep(this.sessionPostOnUpdateBooking);
            this.dictionaryRoutesHostsService.getHostsAvailable(copy)
                .subscribe({
                    next: ((host: string[]) => {
                        if (host?.length) {
                            const dataToSearch = {
                                ...copy,
                                host
                            };
                            this.getPropalData(dataToSearch);
                        } else {
                            this.setRoutHostMessage(this.searchFlightFormWording.incorrectHost);
                        }
                    }),
                    error: (error: ResourceError): void => {
                        // #30996 if not list host available and error make search with actual host
                        this.getPropalData(copy);
                        // uncomment next line to see error message in interface
                        // this.onDictionaryRoutesHostsError.emit(error.message);
                    }
                });
        }
    }

    private closeNamedFormSubscription(): void {
        this.travellerCloseSubscription = this.formBuilderService
            .closeNamedForm
            .subscribe(
                (_data: any): void => {
                    let index = 0;
                    if (_data.index > -1) {
                        index = _data.index + 1;
                    }
                    if (Object.keys(_data).length && _data.formName === 'travellerForm' && index === 0) {
                        //Close the named form
                        this.travellerFormActiv = '';
                    }
                    if (Object.keys(_data).length && _data.formName === 'travellerForm' && index > 0) {
                        //Close the named form
                        this.travellerFormActiv = '';
                        const nextIndex = _data.index + 1;
                        const key = Object.keys(this.travellerService.traveller)[nextIndex];
                        this.travellerFormActiv = key;
                    }
                });
    }

    private silentBooking($post) {
        this.showQuotes = false;
        this.silentBook.show = true;

        this.loader.active = true;
        this.loader.message = this.wording.silentBooking;


        const userInfo = JSON.parse(sessionStorage.getItem("userInformations"));
        const userId: number = userInfo.sam_contact.id;
        const companyId: number = userInfo.sam_company;
        // use moment for clean segment date
        if ($post?.segment?.length) {
            const segment = $post.segment.map((segment: ISegment) => {
                return {
                    ...segment,
                    begin: this.getSegmentBeginMomentDateClean(segment.begin)
                }
            });
            $post = {
                ...$post,
                segment
            };
        }
        this.cacheSamResourceService.getAgentAndCompany(userId, companyId)
            .pipe(
                map(([samAgent, samCompany]: [ISamAgent, ISamCompany]): IAirSilentBookingRequest => {
                    return this.silentBookingService.buildRequest($post, samAgent, samCompany);
                }),
                flatMap((request: IAirSilentBookingRequest): Observable<any> => {
                    return this.silentBookingService.createSilentBooking(request, wenji.ui.target);

                })
            ).subscribe({
                next: (response: any): void => {
                    this.silentBook.error.active = false;
                    this.silentBook.done = true;
                    this.loader.active = false;
                    // if "mustMatchInitialOffer == false" and initial offer wasn't found ==>
                    // from BO : no booking created + success returned with code 204 but didn't succeed to check code here ==>
                    // so checking if syscode is on body ("no syscode === no booking")
                    if (response?.syscode) {
                        this.silentBook.success = true;
                        setTimeout("window.close()", 2000);
                    } else {
                        this.showFlightForm = true;
                        this.silentBook.warning = true;
                    }
                },
                error: (error: ResourceError): void => {
                    this.errorTracingService.captureException(error);
                    this.loader.active = false;
                    this.silentBook.done = true;
                    this.silentBook.error.active = true;
                    this.silentBook.error.message = error.message;
                }
        });
    }

    private silentBestOfferSelection($post) {
        this.showQuotes = false;
        this.resetSaveOffer();

        this.showFlightForm = false;
        this.showQuotes = false;
        this.savingOffer.show = true;

        this.loader.active = true;
        this.loader.message = this.wording.saveOfferRequestCreation;

        const saveBestOfferRequest: IAirApplicationAutomatorRequest = this.offerService.buildRequestSaveBest($post);

        this.loader.message = this.wording.saveBestOfferWaiting;

        this.offerService.saveBestOffer(saveBestOfferRequest, wenji.ui.target)
            .subscribe({
                    next: (response: any): void => {
                        if (response.warningMessage && response.warningMessage.length > 0) {
                            this.savingOffer.warning.active = true;
                            this.savingOffer.warning.message = response.warningMessage;
                        }
                        this.savingOffer.error.active = false;
                        this.loader.active = false;
                        this.savingOffer.done = true;
                        setTimeout("window.close()", 2000);
                    },
                    error: (error: ResourceError): void => {
                        this.errorTracingService.captureException(error);
                        this.loader.active = false;
                        this.savingOffer.done = true;
                        this.savingOffer.error.active = true;
                        this.savingOffer.error.message = error.message;
                    }
                }
            );
    }

    private handleMissingPermission(): void {
        this.showFlightForm = false;
        this.showQuotes = false;
        this.missingPermission = true;
        this.savingOffer.show = false;
        this.silentBook.show = false;
    }

    private getSegmentBeginMomentDateClean(begin: string | ISegmentBeginValue | ISegmentBeginIntervalle): string | ISegmentBeginValue | ISegmentBeginIntervalle {
        if (_isString(begin)) {
            return this.dateService.ensureMoment(begin).format('YYYY-MM-DD');
        } else if (Boolean((begin as ISegmentBeginValue)?.value) && _isString((begin as ISegmentBeginValue).value)) {
            return {
                value: this.dateService.ensureMoment((begin as ISegmentBeginValue).value).format('YYYY-MM-DD')
            };
        } else if (Boolean((begin as ISegmentBeginIntervalle)?.min) && _isString((begin as ISegmentBeginIntervalle).min) ||
                   Boolean((begin as ISegmentBeginIntervalle)?.max) && _isString((begin as ISegmentBeginIntervalle).max)) {
            const minValue: string | null = Boolean((begin as ISegmentBeginIntervalle)?.min) ? this.dateService.ensureMoment((begin as ISegmentBeginIntervalle).min).format('YYYY-MM-DD') : null;
            const maxValue: string | null = Boolean((begin as ISegmentBeginIntervalle)?.max) ? this.dateService.ensureMoment((begin as ISegmentBeginIntervalle).max).format('YYYY-MM-DD') : null;
            const min: ISegmentBeginIntervalle | null = Boolean(minValue) ? { min: minValue } : null;
            const max: ISegmentBeginIntervalle | null = Boolean(maxValue) ? { max: maxValue } : null;
            return {
                ...min,
                ...max
            };
        }
        return begin;
    }
}
